const messages = {
  en: {
    translations: {
      mutes: {
        menuMute: "Mute notifications…",
        menuUnmute: "Unmute",
        title: "Mute notifications",
        d8h: "8 hours",
        d1w: "1 week",
        always: "Always",
        hint: "Messages keep arriving and counting as unread; only sound and alerts stop.",
        groupHint: "Mentions of the connection number still alert.",
        tooltipUntil: "Muted until {{date}}",
        tooltip: "Muted",
        confirm: "Mute",
        cancel: "Cancel",
      },
      metaBusinessAssets: {
        transferTickets: "Transfer tickets",
        defaultFlow: "Default flow",
        connectionIdentity: "Connection details",
        "title": "Authorized Meta accounts",
        "description": "Enter the business portfolio ID and system user token to retrieve accounts owned by that business. This lookup does not change the connection. Select an account and phone number, then click Save to apply.",
        "load": "Retrieve Meta accounts",
        "account": "WhatsApp Business Account",
        "phone": "Authorized phone number",
        "emptyAccounts": "Meta returned no accounts owned by this portfolio. Check the business ID and assets assigned to the system user.",
        "emptyPhones": "No accessible phone numbers were returned for this account.",
        "selected": "The selected account and phone are filled in above. Review the details and click Save to apply them to this connection.",
        "credentialsTitle": "Meta Business API credentials",
        "credentialsHelp": "Server-to-server integration. Configure the system user token in Meta Business and grant access to the business assets. There is no Facebook login on this screen.",
        "phoneIdHelp": "Meta phone number identifier",
        "accountIdHelp": "WhatsApp Business Account identifier (WABA)",
        "businessIdHelp": "Business portfolio ID from Business Manager",
        "phoneHelp": "Full phone number with country code, digits only",
        "tokenHelp": "System user access token. Account discovery requires business_management and applicable WhatsApp permissions. The token stays hidden on screen.",
        "errors": {
          "ERR_META_INVALID_TOKEN": "The token is invalid or expired. Check the system user token in Meta.",
          "ERR_META_INVALID_ID": "Enter a valid business portfolio ID.",
          "ERR_META_BUSINESS_ACCESS": "Meta denied access. Check business_management, WhatsApp permissions and the assets assigned to the system user.",
          "ERR_META_ACCOUNT_NOT_IN_BUSINESS": "The selected account is not owned by this business portfolio.",
          "ERR_META_INVALID_RESPONSE": "Meta returned an incomplete response. Please retry.",
          "ERR_META_TOO_MANY_ASSETS": "The asset lookup exceeded its limit. Contact your administrator.",
          "ERR_NO_PERMISSION": "Only administrators can retrieve Meta business assets.",
          "ERR_NO_WAPP_FOUND": "The connection is not available in this company.",
          "default": "Unable to retrieve Meta accounts. Check the credentials and try again."
        }
      },
      copilot: {
        button: "Suggest reply",
        loading: "Generating...",
        tooltip: "Draft a reply with AI (review before sending)",
        summarize: "Summarize conversation",
        instructions: {
          title: "How to reply",
          default: "Default",
          shorter: "Shorter",
          formal: "More formal",
          invoice: "Explain invoice",
        },
        dialog: {
          title: "Conversation summary",
          loading: "Generating summary with AI...",
          empty: "Could not generate a summary for this conversation.",
          hint: "Generated by AI from the conversation and linked ERP data. Check it before using.",
          save: "Save as note",
          savedLabel: "Note saved",
          copy: "Copy",
          close: "Close",
        },
        toasts: {
          inserted: "Draft inserted — review before sending",
          empty: "The AI returned no suggestion for this conversation.",
          copied: "Summary copied",
          saved: "Summary saved as internal note",
        },
        settings: {
          title: "Copilot (AI)",
          enabled: "Enable copilot",
          enabledHelper: "Reply suggestions and summaries in the ticket view.",
          apiKey: "OpenAI key",
          apiKeyHelper: "Paste the key and leave the field to save.",
          apiKeyConfigured: "Key configured. Type a new one to replace it.",
          model: "Model",
          modelHelper: "gpt-4o-mini is the cheapest and fastest.",
          summarizeOnTransfer: "Summarize on transfer",
          summarizeOnTransferHelper: "Creates a summary note when the ticket is transferred.",
          saved: "Setting updated.",
          keySaved: "Key saved.",
          saveError: "Could not save the setting.",
        },
      },
      auditLogs: {
        title: "Audit log",
        subtitle: "Who did what, when and in which company",
        filters: {
          company: "Company",
          entity: "Entity",
          action: "Action",
          actorEmail: "User e-mail",
          dateFrom: "From",
          dateTo: "To",
          all: "All",
          apply: "Filter",
          clear: "Clear",
          refresh: "Refresh",
        },
        table: {
          date: "Date/time",
          actor: "Who",
          company: "Company",
          action: "Action",
          entity: "Entity",
          route: "Route",
          status: "Status",
          details: "Details",
          actorCompany: "User's company",
          changes: "Submitted data (masked)",
          noChanges: "Request had no body.",
        },
        pagination: { showing: "Showing", of: "of", prev: "Previous", next: "Next" },
        empty: {
          title: "No records found",
          message: "Adjust the filters or wait for new actions in the system.",
        },
        actions: {
          create: "Create",
          update: "Update",
          delete: "Delete",
          login: "Login",
          logout: "Logout",
          other: "Other",
        },
        entities: {
          company: "Company",
          plan: "Plan",
          user: "User",
          queue: "Queue",
          whatsapp: "Connection",
          setting: "Setting",
          queueIntegration: "Integration",
          contact: "Contact",
          contactList: "Contact list",
          quickMessage: "Quick reply",
          campaign: "Campaign",
          tag: "Tag",
          schedule: "Schedule",
          announcement: "Announcement",
          invoice: "Invoice",
          subscription: "Subscription",
          ticketNote: "Ticket note",
          ticket: "Ticket",
          session: "Session",
          isp: "ERP / ISP",
          other: "Other",
        },
      },
      terms: {
        title: "Terms of use",
        description: "To keep using the system, the company administrator must read and accept the terms of use.",
        readLink: "Read the terms of use",
        version: "Version",
        accept: "I have read and accept the terms",
        accepted: "Terms of use accepted.",
        adminMustAccept: "The company administrator must accept the terms of use.",
        acceptPrefix: "I have read and accept the",
        acceptLink: "terms of use",
        mustAccept: "You must accept the terms of use to sign up.",
      },
      signup: {
        title: "Sign Up",
        toasts: {
          success: "User successfully created! Please log in!",
          disabled:
            "User registration is currently disabled. Please try again later.",
          fail: "Error creating user. Please check the provided data.",
        },
        form: {
          name: "Name",
          email: "Email",
          password: "Password",
          company: "Organization Name",
          phone: "WhatsApp (Area Code + Number)",
        },
        buttons: {
          submit: "Register",
          login: "Already have an account? Log in!",
        },
      },
      login: {
        hero: {
          title: "Smart WhatsApp customer service for your business",
          subtitle: "Centralize conversations, automate replies and keep track of your team in one place.",
          feature1: "Official and unofficial WhatsApp",
          feature2: "AI and integrations",
          feature3: "Campaigns and billing",
        },
        title: "Login",
        welcome: "Welcome back",
        loginInstruction: "Enter your credentials to access your account",
        form: {
          email: "Email",
          password: "Password",
          button: "Access",
        },
        buttons: {
          submit: "Enter",
          register: "Don't have an account? Register!",
        },
      },
      companies: {
        title: "Register Company",
        form: {
          name: "Company Name",
          plan: "Plan",
          token: "Token",
          submit: "Register",
          success: "Company successfully created!",
        },
      },

      auth: {
        toasts: {
          success: "Login successful!",
        },
        dueDate: {
          expiration: "Your subscription expires in",
          days: "days!",
          day: "day!",
          expirationToday: "Your subscription expires today!",
        },
        token: "Token",
      },
      dashboard: {
        queueFilter: "Queue",
        allQueues: "All queues",
        filters: "Filters",
        filter: "FILTER ",
        tabs: {
          indicators: "Indicators",
          assessments: "NPS",
          attendants: "Agents",
        },
        charts: {
          perDay: {
            title: "Attendances today: ",
          },
        },
        cards: {
          inAttendance: "In Attendance",
          waiting: "Waiting",
          activeAttendants: "Active Agents",
          finalized: "Finalized",
          newContacts: "New Contacts",
          totalReceivedMessages: "Received Messages",
          totalSentMessages: "Sent Messages",
          averageServiceTime: "Average Service Time",
          averageWaitingTime: "Average Waiting Time",
          status: "Status (Current)",
          activeTickets: "Active Tickets",
          passiveTickets: "Passive Tickets",
          groups: "Groups",
        },
        users: {
          name: "Name",
          numberAppointments: "Number of Attendances",
          statusNow: "Current Status",
          totalCallsUser: "Total Attendances per User",
          totalAttendances: "Total Attendances",
        },
        date: {
          initialDate: "Start Date",
          finalDate: "End Date",
        },
        licence: {
          available: "Available until",
        },
        assessments: {
          totalCalls: "Total Attendances",
          callsWaitRating: "Attendances Waiting for Rating",
          callsWithoutRating: "Attendances Without Rating",
          ratedCalls: "Rated Attendances",
          evaluationIndex: "Evaluation Index",
          score: "Score",
          prosecutors: "Promoters",
          neutral: "Neutral",
          detractors: "Detractors",
        },
      },
      reports: {
        title: "Research Reports",
        operator: "Operator",
        period: "Period",
        until: "Until",
        date: "Date",
        reportTitle: "Reports",
        calls: "Attendances",
        search: "Surveys",
        durationCalls: "Attendance Duration",
        grupoSessions: "Group Attendances",
        groupTicketsReports: {
          timezone: "America/Sao_Paulo",
          msgToast: "Generating compressed report, please wait.",
          errorToast: "Error generating report",
          back: "Back",
          groupServiceReport: "Group Attendance Report",
          loading: "Loading...",
          contact: "Contact",
          dateOpen: "Opening Date",
          dateLastUpdated: "Last Update Date",
          agent: "Agent",
          agentClosed: "Agent who closed",
          waitingAssistance: "Waiting for Service",
          process: "In Service",
        },
        researchReports: {
          response: "Response",
          active: "(Active)",
          inactive: "(Inactive)",
          quantity: "Quantity",
          percentage: "Percentage",
          title: "Research Reports",
          activeSearch: "Active Survey",
          inactiveSearch: "Inactive Survey",
        },
        ticketDurationDetail: {
          msgToast: "Generating compressed report, please wait.",
          title: "Attendance Duration Report",
          startService: "Start of Attendance",
          lastUpdated: "Last Updated",
          lastAgent: "Last Agent",
          durationFinished: "Duration After Closing",
        },
        ticketDuration: {
          title: "Attendance Duration Report",
          contact: "Contact",
          open: "Open",
          pending: "Pending",
          finished: "Finished",
          durationFinished: "Duration of Finished Attendances",
          durationAfterFinished: "Duration After Closing",
          actions: "Actions",
        },
        ticketReports: {
          msgToast: "Generating compressed report, please wait.",
          title: "Attendance Report",
        },
        exportExcel: {
          title: "Attendance Reports",
          startDate: "Start date",
          endDate: "End date",
          notInformed: "Not informed",
          columns: {
            id: "ID",
            connection: "Connection",
            contact: "Contact",
            user: "User",
            queue: "Queue",
            status: "Status",
            lastMessage: "Last Message",
            openDate: "Open Date",
            openTime: "Open Time",
            closeDate: "Close Date",
            closeTime: "Close Time",
            supportTime: "Support Time",
            nps: "NPS",
          },
        },
        pdf: {
          title: "List of Completed Attendances",
          exportTitle: "List of Completed Group Attendances",
        },
      },
      todo: {
        newTask: "New Task",
        add: "Add",
        task: "Tasks",
      },
      contactImportWpModal: {
        title: "Export Contacts to Excel",
        buttons: {
          downloadModel: "Download Excel template for import",
          closed: "Close",
          import: "Select Excel file to import Contacts",
        },
      },
      metaSignup: {
        coexTitle: "Connect a WhatsApp Business app number",
        coexReady: "Click below, sign in with Facebook and pick the number you already use in the WhatsApp Business app. Then confirm on the phone. The app keeps working.",
        coexSync: {
          none: "Coexistence on: the number also stays in the phone app.",
          requested: "We asked Meta for the app contacts and history. They arrive in a few minutes.",
          importing: "Importing the app history… {{count}} messages so far.",
          done: "App history imported ({{count}} messages).",
          declined: "The number owner did not allow sharing the history. New messages arrive normally.",
          failed: "Meta did not accept the contacts/history request. Try \"Sync again\" (only within the first 24 h)."
        },
        title: "Connect WhatsApp through Meta",
        waiting: "Waiting for the Connections screen…",
        loadingSdk: "Loading Meta…",
        ready: "Click below to log in with Facebook and pick (or create) the WhatsApp Business account and phone number.",
        button: "Connect with Facebook",
        working: "Registering the number…",
        done: "Connected! You can close this window.",
        cancelled: "Connection cancelled. Close this window and try again.",
        notEnabled: "Automatic connection is not available for your company. Contact support.",
        fb: "Finish in the Meta window…",
        errors: {
          ERR_META_COEX_ONLY: "This connection is not a coexistence connection.",
          ERR_META_COEX_SYNC_EXPIRED: "Meta only accepts the history request within 24 h of connecting.",
          sdk: "Could not load Meta. Disable ad blockers for this site and try again.",
          onlyWaba: "The window created the WhatsApp Business account but no number was added. Click again and add a number.",
          noIds: "Meta did not return the number data in time. Click again.",
          ERR_META_SIGNUP_CODE: "Meta rejected the code (it expires in 30 seconds). Try again.",
          ERR_META_SIGNUP_SCOPE: "The chosen account did not grant WhatsApp access. Redo it, selecting the account and all permissions.",
          ERR_META_SIGNUP_PHONE: "The chosen number does not belong to the selected WhatsApp Business account.",
          ERR_META_NUMBER_IN_USE: "This number is already connected to another company.",
          ERR_META_SIGNUP_RATE_LIMIT: "Too many attempts. Wait 10 minutes.",
          ERR_META_SIGNUP_NOT_CONFIGURED: "The platform's Meta app is not configured yet.",
          ERR_NO_PERMISSION: "Only the company administrator can connect numbers.",
          generic: "Could not finish. Try again or contact support."
        },
        status: {
          ok: "Number active on the official API.",
          pin_required: "The number already had two-step verification. Enter the 6-digit PIN to finish.",
          not_registered: "Connection created, but webhook/registration failed. Use \"Connect through Meta\" again with the same number.",
          review_pending: "Connection created. The account is still under review by Meta; sending is limited until approval."
        }
      },
      connections: {
        webchat: {
          menu: "Webchat (service page in the browser)",
          copyLink: "Copy link",
          openPage: "Open page",
          linkCopied: "Link copied",
          active: "Page is live",
          inactive: "Page is off",
        },
        metaSignup: {
          coexMenu: "WhatsApp Business app number (coexistence)",
          chip: { pin_required: "PIN pending", not_registered: "Registration pending", review_pending: "Under Meta review", coexistence: "Coexistence" },
          menu: "Connect through Meta (automatic)",
          manual: "WhatsApp Official (manual setup)",
          popupBlocked: "The browser blocked the window. Allow pop-ups for this site and try again.",
          done: "Number connected through Meta!",
          pinRequired: "Connection created. Enter the two-step PIN on the connection screen."
        },
        title: "Connections",
        waitConnection: "Please wait... Your connections will be restarted!",
        newConnection: "New Connection",
        restartConnections: "Restart Connections",
        callSupport: "Call Support",
        connectYourServiceChannelsToReceiveMessagesAndStartConversationsWithYourCustomers:
          " Connect your service channels to receive messages and start conversations with your customers.",
        client: "Client",
        connectedConnections: "Connected connections",
        disconnectedConnections: "Disconnected connections",
        totalConnections: "Total connections",
        total: "Total",
        connections: " Connections:",
        toasts: {
          deleted: "Connection successfully deleted!",
          closedimported:
            "Closing imported tickets, please wait a few moments.",
        },
        confirmationModal: {
          closedImportedTitle: "Close imported tickets",
          closedImportedMessage:
            "If you confirm, all imported tickets will be closed.",
          deleteTitle: "Delete",
          deleteMessage: "Are you sure? This action cannot be undone.",
          disconnectTitle: "Disconnect",
          disconnectMessage:
            "Are you sure? You will need to scan the QR Code again.",
        },
        buttons: {
          add: "Add Connection",
          disconnect: "Disconnect",
          tryAgain: "Try Again",
          qrcode: "QR CODE",
          newQr: "New QR CODE",
          closedImported: "Close all imported tickets",
          preparing: "Preparing messages for import",
          importing: "Importing WhatsApp Messages",
          processed: "Processed",
          in: "of",
          connecting: "Connecting",
        },
        typography: {
          processed: "Processed",
          in: "of",
          date: "Message Date",
        },
        toolTips: {
          disconnected: {
            title: "Failed to start WhatsApp session",
            content:
              "Make sure your phone is connected to the internet and try again, or request a new QR Code.",
          },
          qrcode: {
            title: "Waiting for QR Code scan",
            content:
              "Click the 'QR CODE' button and scan the QR Code with your phone to start the session.",
          },
          connected: {
            title: "Connection established!",
          },
          timeout: {
            title: "Connection with the phone was lost",
            content:
              "Make sure your phone is connected to the internet and WhatsApp is open, or click 'Disconnect' to get a new QR Code.",
          },
        },
        table: {
          name: "Name",
          status: "Status",
          lastUpdate: "Last Update",
          default: "Default",
          actions: "Actions",
          session: "Session",
          number: "WhatsApp Number",
          color: "Color",
        },
      },
      showTicketOpenModal: {
        title: {
          header: "Existing Attendance",
        },
        form: {
          message: "This contact is already being attended to:",
          user: "Agent",
          queue: "Queue",
          messageWait:
            "This contact is already waiting for service. Check the Waiting tab!",
        },
      },
      showTicketLogModal: {
        title: {
          header: "Logs",
        },
        options: {
          create: "Ticket created.",
          chatBot: "ChatBot started.",
          queue: " - Queue assigned.",
          open: " started the service.",
          access: "accessed the ticket.",
          transfered: "transferred the ticket.",
          receivedTransfer: "received the transferred ticket.",
          pending: "returned to the queue.",
          closed: "closed the ticket.",
          reopen: "reopened the ticket.",
          redirect: "- redirected",
          clientClosed: "Client closed the ticket.",
        },
      },
      whatsappModal: {
        webchat: {
          tab: "Page",
          section: "Webchat page",
          title: "Page title",
          titleHelp: "Shown at the top of the page. Empty = connection name.",
          welcomeText: "Welcome text",
          welcomeHelp: "Shown before the customer starts (up to 500 characters).",
          requirePhone: "Ask for the customer's WhatsApp",
          link: "Link to send to customers",
          linkPending: "The link appears after saving.",
          subtitle: " · Webchat",
          closingSection: "Closing message",
        },
        metaSignup: {
          coexTitle: "Coexistence with the WhatsApp Business app",
          coexHint: "The number stays on the phone. Replies sent from the app show up here; the bot does not answer over them.",
          coexResync: "Sync again",
          title: "Connected through Meta",
          review: "Account review",
          quality: "Quality",
          sendPin: "Send PIN",
          pinLabel: "PIN (6 digits)",
          reconnectHint: "To renew access, use New Connection → Connect through Meta and pick the same number."
        },
        title: {
          add: "Add Connection",
          edit: "Edit Connection",
        },
        tabs: {
          general: "General",
          messages: "Messages",
          assessments: "NPS",
          integrations: "Integrations",
          schedules: "Business Hours",
        },
        form: {
          importOldMessagesEnable: "Import messages from device",
          importOldMessages: "Start date of import",
          importRecentMessages: "End date of import",
          importOldMessagesGroups: "Import group messages",
          closedTicketsPostImported: "Close tickets after import",
          name: "Name",
          queueRedirection: "Queue Redirection",
          queueRedirectionDesc:
            "Select a queue for contacts without an assigned queue",
          default: "Default",
          group: "Allow groups",
          timeSendQueue: "Time in minutes to redirect to queue",
          importAlert:
            "WARNING: Saving will terminate your connection. You will need to scan the QR Code again to import messages.",
          groupAsTicket: "Treat groups as ticket",
          timeCreateNewTicket: "Create a new ticket after X minutes",
          maxUseBotQueues: "Send bot X times",
          maxUseInactiveTime: "Send inactivity flow X times",
          timeUseBotQueues: "Send bot in X minutes",
          timeToReturnQueue: "Time to return to queue in minutes",
          timeAwaitActiveFlow: "Time to wait for active flow",
          expiresTicket: "Close open chats after X minutes",
          expiresTicketNPS: "Close chats awaiting evaluation after X minutes",
          maxUseBotQueuesNPS: "Max times evaluation is sent",
          closeLastMessageOptions1: "From agent/client",
          closeLastMessageOptions2: "From agent only",
          outOfHoursMessage: "Out-of-hours message",
          greetingMessage: "Greeting message",
          complationMessage: "Completion message",
          lgpdLinkPrivacy: "Privacy policy link",
          lgpdMessage: "LGPD greeting message",
          lgpdDeletedMessages: "Obfuscate messages deleted by contact",
          lgpdSendMessage: "Always request contact confirmation",
          ratingMessage: "Evaluation message - Scale must be from 0 to 10",
          token: "Token for external integration",
          sendIdQueue: "Queue",
          inactiveMessage: "Inactivity warning message",
          timeInactiveMessage: "Time in minutes to send inactivity warning",
          flowInactiveTime: "Time in minutes to send inactivity flow",
          whenExpiresTicket: "Close chats when the last message is",
          expiresInactiveMessage: "Inactivity closure message",
          prompt: "Prompt",
          collectiveVacationEnd: "End date",
          collectiveVacationStart: "Start date",
          collectiveVacationMessage: "Collective vacation message",
          queueIdImportMessages: "Queue for message import",
          isOficial: "Official",
          phone_number_id: "Phone Number ID",
          waba_id: "WABA ID",
          send_token: "Sending token",
          business_id: "Business ID",
          phone_number: "Phone number",
          triggerIntegrationOnClose: "Trigger Integration on Ticket Close",
          enableIntegration: "Habilited Integration",
        },
        buttons: {
          okAdd: "Add",
          okEdit: "Save",
          cancel: "Cancel",
        },
        menuItem: {
          enabled: "Enabled",
          disabled: "Disabled",
          minutes: "minutes",
        },
        success: "Connection saved successfully.",
        errorSendQueue:
          "You set a redirection time but no queue was selected. Both fields are required.",
        errorExpiresNPS: "A timeout must be set for NPS evaluation.",
        errorRatingMessage: "An evaluation message must be provided for NPS.",
      },
      qrCode: {
        message: "Scan the QR Code to start the session",
      },
      contacts: {
        title: "Contacts",
        toasts: {
          deleted: "Contact successfully deleted!",
        },
        searchPlaceholder: "Search...",
        conversationFlows: " Conversation Flows",
        addFlow: "Add Flow",
        editFlow: "Edit Flow ",
        confirmationModal: {
          deleteTitle: "Delete",
          importTitlte: "Import Contacts",
          exportContact: "Export Contacts",
          deleteMessage:
            "Are you sure you want to delete this contact? All related attendances will be lost.",
          blockContact: "Are you sure you want to block this contact?",
          unblockContact: "Are you sure you want to unblock this contact?",
          importMessage: "Do you want to import all contacts from the phone?",
          importChat: "Import Chats",
          wantImport: "Do you want to import all chats from the phone?",
        },
        buttons: {
          import: "Import Contacts",
          add: "Add Contact",
          export: "Export Contact",
        },
        loading: "Loading...",
        loadMore: "Load More",
        table: {
          name: "Name",
          whatsapp: "Connection",
          email: "Email",
          actions: "Actions",
          lastMessage: "Last Message",
        },
        menu: {
          importYourPhone: "Import from default device",
          importToExcel: "Import/Export from Excel",
          importexport: "IMPORT / EXPORT ",
        },
      },
      forwardMessage: {
        text: "Forwarded",
      },
      forwardMessageModal: {
        title: "Forward Message",
        buttons: {
          ok: "Forward",
        },
      },
      promptModal: {
        form: {
          name: "Name",
          prompt: "Prompt",
          voice: "Voice",
          max_tokens: "Maximum Tokens in Response",
          temperature: "Temperature",
          apikey: "API Key",
          max_messages: "Maximum Messages in History",
          voiceKey: "Voice API Key",
          voiceRegion: "Voice Region",
        },
        success: "Prompt saved successfully!",
        title: {
          add: "Add Prompt",
          edit: "Edit Prompt",
        },
        buttons: {
          okAdd: "Add",
          okEdit: "Save",
          cancel: "Cancel",
        },
      },
      prompts: {
        title: "Prompts",
        table: {
          name: "Name",
          queue: "Sector/Queue",
          max_tokens: "Max Tokens in Response",
          actions: "Actions",
        },
        confirmationModal: {
          deleteTitle: "Delete",
          deleteMessage: "Are you sure? This action cannot be undone!",
        },
        buttons: {
          add: "Add Prompt",
        },
      },
      contactModal: {
        title: {
          add: "Add Contact",
          edit: "Edit Contact",
        },
        form: {
          mainInfo: "Contact Data",
          extraInfo: "Additional Information",
          name: "Name",
          number: "WhatsApp Number",
          webchatNumber: "Webchat contact: the number is internal and cannot be changed.",
          email: "Email",
          extraName: "Field Name",
          extraValue: "Value",
          chatBotContact: "Disable Chatbot",
          termsLGDP: "LGPD Terms accepted on:",
          whatsapp: "Origin Connection:",
        },
        buttons: {
          addExtraInfo: "Add Information",
          okAdd: "Add",
          okEdit: "Save",
          cancel: "Cancel",
        },
        success: "Contact saved successfully.",
        walletLinked: "Contact linked to your wallet successfully!",
        walletError: "User has no associated queues",
        saveFirst: "Contact must be saved first",
      },
      wallets: {
        title: "Contact Wallets",
        searchPlaceholder: "Search contacts...",
        filterByUser: "Filter by User",
        allUsers: "All users",
        contact: "Contact",
        user: "User",
        queue: "Queue",
        phone: "Phone",
        email: "Email",
        actions: "Actions",
        editWallet: "Edit Wallet",
        selectUser: "Select User",
        selectQueue: "Select Queue",
        selectUserAndQueue: "Select a user and queue",
        cancel: "Cancel",
        save: "Save",
        confirmDeleteTitle: "Confirm Deletion",
        confirmDeleteMessage:
          "Are you sure you want to remove this contact from the wallet?",
        deleteSuccess: "Contact removed from wallet successfully!",
        updateSuccess: "Wallet updated successfully!",
      },
      sla: {
        kind: { firstResponse: "First response", resolution: "Resolution" },
        status: { ok: "On time", warning: "Warning", breached: "Breached" },
        toast: {
          breached: "SLA breached ({{kind}}): {{contact}}",
          breachedWithQueue: "SLA breached ({{kind}}): {{contact}} ({{queue}})",
          unknownContact: "contact",
        },
        dashboard: {
          title: "SLA",
          hint: "Time targets met in the filtered period and queue",
          pctFirst: "First response on time",
          pctResolution: "Resolution on time",
          avgFirstResponse: "Avg. first response",
          avgResolution: "Avg. resolution",
          total: "{{count}} tickets with SLA",
        },
      },
      aiLearning: {
        title: "AI learning",
        subtitle: "How this company's AI agents improve from resolved conversations",
        refresh: "Refresh",
        settings: {
          title: "Settings",
          enabled: "Learning on",
          enabledHint: "The AI learns from this company's conversations — never from others — and only changes how it speaks. Prices and rules don't change.",
          approval: "Require my approval for new lessons",
          approvalHint: "New lessons stay pending until you approve or reject them here.",
          saved: "Settings saved",
          noAgent: "This company has no AI agent yet (AI integration or prompt). Learning starts once there is one.",
          cost: "Cost: learning calls only show up in AI usage when they use the platform key. Integrations with their own key are billed directly to the company's OpenAI account and don't show here.",
        },
        lastRun: {
          title: "Last run",
          never: "Hasn't run yet. The routine runs overnight (04:00).",
          at: "{{date}}",
          summary: "{{evaluated}} conversations evaluated · {{created}} new lessons · {{reinforced}} reinforced · {{discarded}} discarded · {{memories}} customer memories",
          discardedBy: "Discarded for: {{list}}",
          cost: "Run cost (platform key): {{value}}",
          skipped: "Learned nothing: {{reason}}",
        },
        skipped: {
          disabled: "learning is off for this company",
          no_agent: "the company has no AI agent",
          quota: "plan AI usage limit reached",
          volume: "too few successful conversations (minimum 10)",
          no_key: "no OpenAI key available (own or platform)",
          platform_off: "routine is off on the platform",
          locked: "another run was in progress",
          extractionPrefix: "while extracting lessons: {{reason}}",
        },
        discard: {
          pii: "personal data",
          filter: "safety rule",
          regra: "safety rule",
          from_customer: "came from the customer, not the team",
          judge: "failed review",
          judge_injection: "batch with suspicious instruction",
        },
        cards: {
          successRate: "Success this week",
          pp: "{{value}} pp",
          vsLastWeek: "vs last week",
          noData: "no conversations",
          aiShare: "Handled by AI",
          aiShareHint: "AI only {{ai}} · mixed {{mixed}}",
          evaluated: "Conversations evaluated",
          evaluatedHint: "in the last {{weeks}} weeks",
          activeLessons: "Active lessons",
          pendingHint: "{{count}} awaiting approval",
        },
        chart: {
          title: "Success rate per week",
          hint: "Conversations closed successfully over the week's total",
          tooltip: "Week of {{week}}: {{success}} of {{total}} ({{rate}})",
          empty: "no data",
          week: "Week",
          success: "Success",
          total: "Total",
        },
        funnel: {
          title: "Sales funnel",
          chegou: "Arrived",
          cotou: "Got a quote",
          proposta: "Got a proposal",
          fechou: "Closed",
        },
        stops: {
          title: "Where customers stop",
          hint: "Unsuccessful conversations, by where the customer stopped",
          empty: "Nothing recorded yet.",
        },
        reasons: {
          title: "Reasons",
          empty: "Nothing recorded yet.",
          fatura_em_aberto: "invoice still open",
          reaberto_48h: "customer came back within 48 h",
          sem_mensagem_cliente: "customer didn't write",
          sem_resposta_humana: "no reply from the team",
        },
        lessons: {
          title: "Lessons",
          hint: "What the AI learned and uses in conversations. Turn off anything that doesn't make sense.",
          text: "Lesson",
          origin: "Origin",
          agent: "Agent",
          weight: "Weight",
          lastSeen: "Last seen",
          status: "Status",
          showExample: "Show example",
          hideExample: "Hide example",
          approve: "Approve",
          reject: "Reject",
          toggle: "Lesson on",
          updated: "Lesson updated",
          emptyTitle: "Still learning",
          emptyMessage: "The first lessons show up after the first night with at least 10 successful conversations.",
          filterEmpty: "No lessons with this status.",
          originLabels: {
            human: "Team",
            ai: "AI",
            mixed: "Team + AI",
          },
          agentLabels: {
            hospedagem: "Hospitality",
            isp: "ISP support",
            generic: "Prompt/AI",
            none: "—",
          },
          statusLabels: {
            all: "All",
            active: "Active",
            pending: "Pending",
            disabled: "Off",
            expired: "Expired",
          },
        },
      },
      ratings: {
        title: "Ratings",
        subtitle: "Scores given by customers at the end of the service, per agent",
        refresh: "Refresh",
        cards: {
          total: "Ratings",
          avg: "Average (0–10)",
          otimo: "% Great",
          ruim: "% Bad",
          responseRate: "Response rate",
        },
        filters: {
          dateFrom: "From",
          dateTo: "To",
          attendant: "Agent",
          allAttendants: "All",
          queue: "Queue",
          allQueues: "All",
          apply: "Filter",
        },
        labels: {
          otimo: "Great",
          regular: "Regular",
          ruim: "Bad",
        },
        attendants: {
          title: "By agent",
          hint: "Sorted by average in the period",
          name: "Agent",
          avg: "Average",
          count: "Ratings",
          distribution: "Great / Regular / Bad",
          closedTickets: "Closed tickets",
          responseRate: "% response",
          empty: "No ratings in the period",
        },
        list: {
          title: "Received ratings",
          hint: "Most recent first",
          date: "Date",
          contact: "Contact",
          attendant: "Agent",
          queue: "Queue",
          rate: "Score",
          ticket: "Ticket",
          showing: "Showing {{from}}–{{to}} of {{count}}",
          prev: "Previous",
          next: "Next",
          emptyTitle: "No ratings found",
          emptyMessage: "Adjust the period or filters. Ratings appear when the customer answers the question sent when the ticket is closed.",
        },
      },
      supervision: {
        title: "Supervision",
        subtitle: "Waiting queue, agents and SLA in real time",
        refresh: "Refresh",
        updatedAt: "Updated {{time}}",
        cards: {
          waiting: "Waiting",
          oldestWaiting: "Oldest waiting",
          open: "In progress",
          breached: "SLA breached now",
          online: "Agents online",
        },
        queues: {
          title: "Queues",
          hint: "Each queue right now and today's SLA compliance",
          queue: "Queue",
          waiting: "Waiting",
          oldest: "Oldest",
          open: "In progress",
          warning: "Warning",
          breached: "Breached",
          slaToday: "% within SLA today",
          noSla: "no target",
          emptyTitle: "No queue has an SLA configured",
          emptyMessage: "Set first-response and resolution targets in Queues & Chatbot → edit queue → SLA section.",
          emptyAction: "Go to Queues",
        },
        agents: {
          title: "Agents",
          hint: "Who is online and each one's workload",
          online: "Online",
          offline: "Offline",
          lastSeen: "seen {{ago}}",
          openTickets: "Open",
          breached: "Breached",
          avgFirstResponse: "Avg. first response today",
          empty: "No agents registered",
        },
        time: {
          now: "just now",
          minutes: "{{count}} min ago",
          hours: "{{count}} h ago",
          days: "{{count}} d ago",
          never: "never",
        },
        forbidden: "You do not have permission to access this page",
      },
      queueModal: {
        title: {
          queueData: "Queue Data",
          text: "Business Hours",
          add: "Add Queue",
          edit: "Edit Queue",
          confirmationDelete:
            "Are you sure? All integration options will be deleted.",
        },
        form: {
          slaTitle: "SLA (time targets)",
          slaFirstResponse: "First response (min)",
          slaResolution: "Resolution (min)",
          slaWarning: "Warn at (%)",
          slaHint: "Empty = no target. The warning (amber) shows when the given percentage of the target is reached.",
          tipoIntegracao: "Integration Type (ERP)",
          name: "Name",
          color: "Color",
          orderQueue: "Queue Order (Bot)",
          rotate: "Rotation",
          timeRotate: "Rotation Time",
          typeRandomMode: "Rotation Type",
          greetingMessage: "Greeting Message",
          complationMessage: "Completion Message",
          outOfHoursMessage: "Out-of-Hours Message",
          token: "Token",
          integrationId: "Integration",
          fileListId: "File List",
          closeTicket: "Close Ticket",
          queueType: "Menu Type",
          message: "Return Message",
          queue: "Transfer Queue",
          integration: "Integration",
          file: "File List",
        },
        buttons: {
          okAdd: "Add",
          okEdit: "Save",
          cancel: "Cancel",
        },
        bot: {
          title: "Options",
          toolTipTitle: "Add options to build a chatbot",
          toolTip:
            "If there is only one option, it will be automatically chosen, and the bot will respond with the message and proceed",
          selectOption: "Select an Option",
          text: "Text",
          attendent: "Agent",
          queue: "Queue",
          integration: "Integration",
          file: "File",
          toolTipMessageTitle:
            "Message is required to proceed to the next level",
          toolTipMessageContent:
            "Message is required to proceed to the next level",
          selectUser: "Select a User",
          selectQueue: "Select a Queue",
          selectIntegration: "Select an Integration",
          addOptions: "Add Options",
        },
        serviceHours: {
          dayWeek: "Day of the Week",
          startTimeA: "Start Time - Shift A",
          endTimeA: "End Time - Shift A",
          startTimeB: "Start Time - Shift B",
          endTimeB: "End Time - Shift B",
          monday: "Monday",
          tuesday: "Tuesday",
          wednesday: "Wednesday",
          thursday: "Thursday",
          friday: "Friday",
          saturday: "Saturday",
          sunday: "Sunday",
        },
      },
      erp: {
        integrationTypes: {
          NA: "None",
          SB: "Invoice copy",
          AV: "Due soon",
          VE: "Overdue",
          LC: "Trust unlock",
          ST: "Connection status",
        },
        sgpModes: {
          auto: "Automatic (URA when App and Token are set)",
          central: "Subscriber portal only",
          ura: "URA API only",
        },
        validation: {
          nameRequired: "Integration name is required.",
          sgpUrlRequired: "SGP URL is required.",
          sgpAppRequired: "Enter the SGP App to use the URA API only mode.",
          sgpTokenRequired: "Enter the SGP app token to use the URA API only mode.",
          sgpUraPairRequired: "Enter both App and app token to enable the SGP URA API.",
          sgpModeInvalid: "Invalid SGP mode.",
          ixcUrlRequired: "IXC base URL is required.",
          ixcTokenRequired: "IXC API token is required.",
          asaasApiKeyRequired: "Asaas API key is required.",
          asaasEnvironmentInvalid: "Invalid Asaas environment.",
          urlInvalid: "Invalid URL. Use the https://... format",
          timeoutInvalid: "Timeout must be a number greater than zero.",
          erpIntegrationRequired: "Select the ERP integration (SGP or IXC).",
          openaiApiKeyRequired: "OpenAI API key is required.",
          maxTurnsInvalid: "Max turns must be an integer greater than zero.",
          hotspotBaseUrlRequired: "Hotspot URL is required.",
          hotspotApiKeyRequired: "Hotspot API key is required.",
          hospedagemProviderRequired: "Select the lodging provider.",
          hospedagemBaseUrlRequired: "Site URL is required.",
          hospedagemApiKeyRequired: "API key is required.",
          hospedagemIntegrationRequired: "Select the lodging connector.",
          hospedagemNomeAgenteRequired: "Agent name is required.",
          hospedagemNomeEmpresaRequired: "Company name is required.",
          hospedagemPersonaRequired: "Agent persona is required.",
        },
      },
      systemResources: {
        title: "Server",
        subtitle: "Hardware usage of the machine running the system",
        collectedAt: "Collected at {{time}}",
        autoRefresh: "Refresh every 15 s",
        refresh: "Refresh",
        live: "live",
        loading: "Loading…",
        error: "Could not read server resources.",
        cpu: "CPU",
        cpuHint: "{{cores}} cores · load {{load}}",
        memory: "Memory",
        disk: "Disk",
        uptime: "Server up for",
        processUptime: "backend up for {{time}}",
        cpuSection: "Processor",
        cpuUsage: "CPU usage",
        cpuSample: "Average of all cores over 0.5 s",
        cpuModel: "Model",
        cores: "Cores",
        loadAvg: "Load average (1 · 5 · 15 min)",
        memorySection: "Memory",
        ram: "RAM",
        swap: "Swap",
        memoryHint: "{{available}} available",
        total: "Total",
        used: "Used",
        available: "Available",
        disksSection: "Disks",
        diskHint: "{{used}} of {{size}} · {{free}} free",
        noDisk: "No disk found",
        processSection: "Process and database",
        node: "Node.js",
        processUptimeLabel: "Backend up for",
        rss: "Backend memory (RSS)",
        heap: "Heap used / total",
        database: "Database",
        databaseSize: "Database size",
      },
      aiUsage: {
        title: "AI usage",
        used: "Used this month",
        credit: "Plan credit",
        cap: "Cap",
        extra: "Extra credit",
        kinds: { chat: "Chat", transcription: "Audio transcription", tts: "Voice reply" },
        noCredit: "Your plan does not include AI through the platform key.",
        onlyMeasuring: "Measuring mode: usage is recorded but never blocks.",
        byDay: "Usage per day",
        history: "History",
        model: "Model",
        date: "Date",
        value: "Amount",
        noUsage: "No usage recorded this month.",
        companyColumn: "AI (month)",
        platform: {
          metaApp: {
            title: "Meta app (official API)",
            appId: "App ID",
            configId: "Configuration ID (Embedded Signup)",
            secret: "App secret",
            secretSet: "••••••• (saved)",
            fromEnv: "from .env",
            save: "Save",
            saved: "Meta app saved.",
            help: "With all three values, the \"Connect through Meta\" button shows up in Connections for companies whose plan allows the official API."
          },
          title: "Platform AI",
          subtitle: "Shared key, price table and usage per company",
          settings: "Settings",
          key: "Platform OpenAI key",
          keySet: "Key configured",
          keyPlaceholder: "Paste the key (not shown afterwards)",
          usdBrl: "Exchange rate US$ → R$",
          multiplier: "Profit multiplier",
          visionModel: "Vision model (photo/PDF reading)",
          visionModelHelp: "Default gpt-4o-mini. Used by the flow node \"Read file\".",
          quotaMessage: "Message to the customer when the quota runs out",
          prices: "Price table (US$)",
          model: "Model",
          inputPerMillion: "Input / 1M tokens",
          outputPerMillion: "Output / 1M tokens",
          audioPerMinute: "Audio / minute",
          ttsPerMillionChars: "Voice / 1M characters",
          active: "Active",
          addModel: "Add model",
          newModelPrompt: "Model name (e.g. gpt-4o-mini)",
          companies: "Usage per company",
          company: "Company",
          period: "Period",
          used: "Used",
          cost: "Cost",
          charged: "Charged",
          profit: "Profit",
          credit: "Credit",
          cap: "Cap",
          enforce: "Block when the cap is reached",
          enforceOn: "Blocks",
          enforceOff: "Measure only",
          extraCredit: "Grant extra credit",
          extraCreditPrompt: "Extra credit (R$) for this month:",
          extraCreditSaved: "Extra credit granted",
          enforceSaved: "Blocking updated",
          close: "Close month",
          confirmClose: "Close month {{period}}? Statements will be generated and the overage goes to the next invoice.",
          closed: "Month closed: {{n}} statements, overage R$ {{v}}",
          noCompanies: "No company used AI in this period.",
          saved: "Saved",
          save: "Save"
        },
        plan: { credit: "AI credit/month (R$)", multiplier: "Cap (× credit)" }
      },
      billingRules: {
        title: "Billing reminders",
        buttons: {
          new: "New rule",
          create: "Create rule",
          save: "Save",
          cancel: "Cancel",
          close: "Close",
          preview: "Preview",
          runNow: "Run now",
          history: "History",
          testSend: "Send a test to a number",
          edit: "Edit",
          delete: "Delete",
        },
        stage: {
          beforeDays: "{{count}} day before",
          beforeDays_plural: "{{count}} days before",
          due: "On due date",
          afterDays: "{{count}} day after",
          afterDays_plural: "{{count}} days after",
        },
        table: {
          copyButtons: "Copy buttons (PIX / barcode / open boleto)",
          copyButtonsShort: "Buttons",
          sendPdf: "Attaches the boleto PDF after the message",
          name: "Name",
          stage: "Stage",
          erp: "ERP",
          connection: "Connection",
          template: "Template / text",
          sendHour: "Time",
          active: "Active",
          lastRun: "Last run",
          actions: "Actions",
          metaTemplate: "Meta template (official WhatsApp)",
          officialConnection: "Official WhatsApp (Meta)",
          viewCampaign: "View campaign",
        },
        totals: {
          total: "Total",
          sent: "Sent",
          failed: "Failed",
          skipped: "Skipped",
        },
        modal: {
          newTitle: "New billing rule",
          editTitle: "Edit billing rule",
        },
        form: {
          sendPdf: "Attach boleto PDF (non-official WhatsApp)",
          sendPdfHelp: "After the text, the boleto PDF is sent as a document. If the PDF fails, the text still counts as sent.",
          sendPdfOfficialHelp: "Only on non-official connections. Official WhatsApp (Meta) sends the approved template only.",
          copyButtons: "Copy buttons (Copy PIX · Copy barcode · Open boleto)",
          copyButtonsHelp:
            "The customer gets the text without the long codes plus three native WhatsApp buttons: Copy PIX, Copy barcode and Open boleto. If the device does not support buttons, the full text with the codes is sent.",
          copyButtonsOfficialHelp:
            "On official WhatsApp, Meta does not allow copy buttons for long codes (15-character limit). Check to fill the template's \"Open boleto\" link button (dynamic URL https://…/b/{{1}}); PIX and barcode go in the template body.",
          name: "Rule name",
          erpIntegration: "ERP integration",
          whatsapp: "WhatsApp connection",
          official: "official",
          none: "None",
          stage: "When to send",
          stageBefore: "Before due date",
          stageDue: "On due date",
          stageAfter: "After due date",
          offsetDays: "Days",
          sendHour: "Send time",
          metaTemplate: "Approved template",
          metaTemplateHelp: "Only templates approved by Meta can be used on this connection.",
          loadingTemplates: "Loading templates…",
          noApprovedTemplates: "No approved template for this connection. Create and approve one under WhatsApp Templates.",
          goToTemplates: "Go to WhatsApp Templates",
          variablesHelp: "Click a variable to insert it into the text:",
          textTemplate: "Message text",
          replyQueue: "Queue for customer replies",
          replyQueueHelp: "Replies to a charge sent in the last 24 h go straight to this queue, skipping the sector menu.",
          defaultTemplate:
            "Hello {nome}! Your invoice of {valor} is due on {vencimento}.\n\nBarcode: {linhaDigitavel}\nPIX copy & paste: {pix}\n\nIf you already paid, please ignore this message.",
          active: "Rule active",
          activeHelp: "Active rules run automatically every day at the configured time.",
        },
        validation: {
          nameRequired: "Enter a name with at least 2 characters.",
          erpRequired: "Select the ERP integration.",
          whatsappRequired: "Select the WhatsApp connection.",
          stageRequired: "Select the stage.",
          offsetDaysInvalid: "Enter a number of days between 1 and {{max}}.",
          sendHourInvalid: "Invalid time.",
          templateRequired: "Select an approved template.",
          textRequired: "Enter the message text.",
          fixErrors: "Fix the highlighted fields.",
        },
        preview: {
          title: "Reminder preview",
          loading: "Fetching invoices from the ERP…",
          count: "Invoices that would be included today",
          warnings: "Warnings",
          samples: "Message samples",
          noSamples: "No invoice found for this stage today.",
          dueDate: "Due date",
          amount: "Amount",
        },
        runs: {
          title: "Run history",
          empty: "This rule has not run yet.",
          date: "Date",
          status: "Status",
          totals: "Totals",
          campaign: "Campaign",
        },
        runStatus: {
          pending: "Pending",
          running: "Running",
          finished: "Finished",
          failed: "Failed",
          skipped: "No invoices",
        },
        confirm: {
          runTitle: "Run rule now",
          runMessage: "An invoice campaign will be created and messages will start being sent immediately. Continue?",
          deleteTitle: "Delete rule",
          deleteMessage: "The rule will stop running. Campaigns it already generated will not be deleted.",
        },
        testSend: {
          title: "Send test",
          help: "Takes the first invoice of this rule's stage today and sends it only to the given number (same text, buttons and PDF as the real run). Nothing is recorded on the rule.",
          number: "Number with area code (e.g. 51999998888)",
          numberInvalid: "Enter area code + number (10 to 13 digits).",
          send: "Send test",
          sentTo: "Sent to",
          invoiceOf: "Invoice used",
          followUp: "Follow the delivery in Campaigns → Invoice campaigns (campaign #{{id}}).",
        },
        toasts: {
          testSent: "Test sent to {{number}}. Follow it in Invoice campaigns.",
          created: "Rule created.",
          updated: "Rule updated.",
          deleted: "Rule deleted.",
          activated: "Rule activated.",
          deactivated: "Rule deactivated.",
          runStarted: "Run started: {{total}} invoice(s) in campaign #{{campaignId}}.",
        },
        empty: {
          noErpTitle: "No ERP integration configured",
          noErpText: "Billing reminders fetch invoices from your ERP (SGP or IXC). Set up an integration under Queues & Chatbot → Integrations to get started.",
          noErpAction: "Go to Integrations",
          noRulesTitle: "Build your billing reminders",
          noRulesText: "Each rule automatically sends a WhatsApp message to customers with an invoice at a given stage: a few days before the due date, on the day, or after it is overdue. Example:",
          exampleBefore: "reminder before due date",
          exampleDue: "notice on due date",
          exampleAfter: "overdue invoice reminder",
        },
      },
      networkAlerts: {
        index: {
          loading: "Checking the ERP database…",
          updatedAt: "ERP database updated on {{date}} · {{rows}} records",
          running: "Indexing… page {{page}} ({{indexed}} records)",
          never: "This ERP database has not been indexed yet.",
          error: "Last indexing failed: {{error}}",
          reindex: "Index now",
          started: "Indexing started; it takes a few minutes.",
          emptyTitle: "This ERP database has not been indexed yet",
          emptyMessage: "Area search uses a local copy of the SGP database. Click Index now and wait a few minutes.",
          emptyMessageUser: "Area search uses a local copy of the SGP database. Ask an administrator to index it.",
        },
        title: "Outage Alerts",
        subtitle: "Warn customers in an affected area and let the bot answer for you while the outage lasts.",
        activeBadge: "{{count}} ongoing",
        tabs: { search: "Find customers", alerts: "Alerts" },
        buttons: {
          newAlert: "New alert",
          search: "Search",
          createAlert: "Create alert for this scope",
          broadcastNow: "Send notice now",
          edit: "Edit",
          close: "Close",
          broadcast: "Send notice",
          delete: "Delete",
          cancel: "Cancel",
          save: "Save",
          saveAndBroadcast: "Save and send",
          send: "Send",
          done: "Done",
          prev: "Previous",
          next: "Next",
          viewCampaign: "View campaign",
          goToIntegrations: "Set up ERP integration",
        },
        scope: {
          pon: "PON",
          olt: "OLT",
          nas: "Concentrator",
          city: "City",
          region: "Region",
          all: "All customers",
          placeholder: {
            pon: "e.g. 1/2/3",
            olt: "e.g. OLT-DOWNTOWN",
            nas: "e.g. NAS-01 or 10.0.0.1",
            city: "e.g. Belo Horizonte",
            region: "e.g. North Zone",
          },
        },
        search: {
          erp: "ERP",
          by: "Search by",
          value: "Value",
          total: "customer(s) found",
          page: "Page {{page}}",
          unsupported: "This ERP does not provide {{fields}}; search by city or region instead.",
          unsupportedBy: "This ERP does not support searching by {{field}}; search by city or region instead.",
          idle: {
            title: "Find the customers of an area",
            message: "Pick the type (PON, OLT, concentrator, city or region), enter the value and click Search.",
          },
          empty: {
            title: "No customers found",
            message: "Check the value or try another search type.",
          },
        },
        table: {
          name: "Customer",
          contract: "Contract",
          phones: "Phone(s)",
          city: "City / District",
          olt: "OLT",
          pon: "PON",
          nas: "Concentrator",
        },
        filters: { active: "Active", closed: "Closed", all: "All" },
        card: {
          status: { active: "Ongoing", closed: "Closed" },
          startsAt: "Started",
          endsAt: "ETA",
          noEnds: "No ETA",
          affected: "Affected customers",
          createdBy: "Created by",
          erp: "ERP",
          campaign: "Campaign #{{id}}",
        },
        empty: {
          noErp: {
            title: "No ERP integration configured",
            message: "Add an SGP or IXC integration under Queues & Chatbot → Integrations to search customers by area.",
          },
          noAlerts: {
            title: "No active alerts",
            message: "How it works:",
            step1: "Find the customers of the affected area (PON, OLT, concentrator, city or region).",
            step2: "Create the alert with a short title and the message the bot will send.",
            step3: "Optional: send the notice right away to every customer in the scope.",
          },
          noAlertsFiltered: {
            title: "No alerts for this filter",
            message: "Change the filter to see active or closed alerts.",
          },
        },
        form: {
          titleNew: "New alert",
          titleEdit: "Edit alert",
          subtitle: "While the alert is active, the bot and the AI automatically warn customers in the scope.",
          erp: "ERP",
          scopeType: "Scope",
          scopeValue: "Scope value",
          scopeAllHelp: "Every customer of this integration will be warned.",
          title: "Short title",
          titlePlaceholder: "e.g. Power failure at OLT Downtown",
          message: "Message to the customer",
          messagePlaceholder: "e.g. Our team is already on site working on the fix.",
          messageHelp: "Write as if talking to the customer. No technical jargon.",
          preview: "How the bot will send it",
          startsAt: "Start",
          endsAt: "Estimated fix time",
          endsAtHelp: "Optional. Included in the bot message.",
          active: "Alert active",
        },
        preview: {
          withEnds: "⚠️ {{body}}. Estimated fix time: {{endsAt}}",
          withoutEnds: "⚠️ {{body}}.",
          placeholder: "Fill in the title and message to see the preview.",
        },
        validation: {
          erpRequired: "Select the ERP integration.",
          scopeValueRequired: "Enter the scope value.",
          titleRequired: "Enter a title.",
          messageRequired: "Enter the message to the customer.",
          endsBeforeStarts: "The estimated fix time must be after the start.",
        },
        confirm: {
          closeTitle: "Close \"{{title}}\"?",
          closeMessage: "The bot stops warning customers in this scope. The alert stays in the history.",
          deleteTitle: "Delete \"{{title}}\"?",
          deleteMessage: "This cannot be undone. Campaigns already sent are not affected.",
        },
        broadcast: {
          testNumber: "Send only to one number (test)",
          testNumberHelp: "Filled: sends 1 message only to this number, with the first customer's name, without marking the alert as broadcast. Empty: sends to everyone.",
          title: "Send notice",
          whatsapp: "Connection",
          official: "Official",
          noConnections: "No WhatsApp connection available.",
          template: "Approved template",
          templateHelp: "Official connections can only send templates approved by Meta.",
          loadingTemplates: "Loading templates…",
          noTemplates: "No approved template on this connection. Create and approve a template before sending.",
          text: "Message",
          textHelp: "Pre-filled with the alert message. You can adjust it.",
          recipients: "Recipients",
          recipientsUnknown: "everyone in scope",
          acknowledge: "I understand this will send {{count}} messages.",
          acknowledgeUnknown: "I understand this will send one message to every customer in the scope.",
          resultTitle: "Notice queued",
          resultMessage: "Campaign #{{id}} created with {{total}} messages. Track progress under Invoice campaigns.",
        },
        toasts: {
          testSent: "Alert test sent to {{number}}.",
          created: "Alert created.",
          updated: "Alert updated.",
          closed: "Alert closed.",
          deleted: "Alert deleted.",
          broadcastStarted: "Sending started: {{total}} messages queued.",
        },
      },
      hotspot: {
        tabelas: {
          none: "—",
          varejo: "Retail",
          atacado: "Wholesale",
        },
        title: "Hotspot",
        subtitle: "Vouchers, devices and payments for the Wi-Fi hotspot.",
        tabs: {
          vouchers: "Vouchers",
          devices: "Devices",
          payments: "Payments",
          summary: "Summary",
        },
        comingSoon: "Coming soon.",
        notConfigured: {
          title: "Hotspot not configured",
          text: "Set up the Hotspot integration under Queues & Chatbot → Integrations to start generating vouchers.",
          action: "Configure integration",
        },
        unavailable: {
          title: "Could not load Hotspot",
          text: "There was an error reaching the integration. Please try again shortly.",
          action: "Try again",
        },
        totals: {
          batches: "Batches",
          vouchers: "Vouchers",
          available: "Available",
          used: "Used",
          canceled: "Canceled",
        },
        search: {
          placeholder: "Search by batch name…",
        },
        table: {
          name: "Name",
          device: "Device",
          duration: "Duration",
          quantity: "Quantity",
          available: "Avail. / Used",
          status: "Status",
          createdAt: "Created at",
          actions: "Actions",
          noDevice: "No device",
          empty: "No batches found.",
        },
        batchStatus: {
          liberado: "Released",
          aguardando_pagamento: "Awaiting payment",
        },
        buttons: {
          new: "New batch",
          viewVouchers: "View vouchers",
          pdf: "PDF",
          copyPixLink: "Copy Pix link",
          sendWhatsapp: "Send via WhatsApp",
          tryAgain: "Try again",
          close: "Close",
          cancel: "Cancel",
          save: "Save",
          copy: "Copy",
          send: "Send",
        },
        toasts: {
          linkCopied: "Link copied.",
          pixCopied: "Pix code copied.",
          codeCopied: "Code copied.",
          pdfError: "Could not open the PDF.",
          batchCreated: "Batch created successfully.",
          sent: "Sent successfully.",
        },
        newBatch: {
          title: "New voucher batch",
          name: "Batch name",
          namePlaceholder: "E.g.: Today's vouchers",
          quantity: "Quantity",
          duration: "Duration",
          durationCustom: "Custom duration",
          durationCustomPlaceholder: "Value",
          durationUnit: "Unit",
          units: { min: "Minutes", h: "Hours", d: "Days" },
          device: "Device",
          deviceDefault: "Integration default",
          priceLabel: "Price label (optional)",
          priceLabelPlaceholder: "E.g.: $5.00 / 2h",
          wholesale: "Wholesale price",
          retail: "Retail price",
          generateCharge: "Generate Pix charge",
          chargeRequired: "Generating the Pix charge is required for your profile.",
          submit: "Create batch",
          creating: "Creating…",
          quantityInvalid: "Enter a quantity between 1 and 500.",
        },
        result: {
          title: "Batch created",
          qrTitle: "Pix QR Code",
          pixCopyPaste: "Pix copy & paste",
          link: "Payment link",
          done: "Done",
        },
        detail: {
          title: "Batch vouchers",
          code: "Code",
          status: "Status",
          usedAt: "Used at",
          empty: "No vouchers found.",
          loading: "Loading vouchers…",
        },
        sendDialog: {
          title: "Send via WhatsApp",
          help: "Enter the number that will receive the batch (PDF or payment link).",
          number: "Number (with area code)",
          numberInvalid: "Invalid number.",
          send: "Send",
        },
        send: {
          button: "Send Wi-Fi vouchers",
          title: "Send Wi-Fi vouchers",
          searchPlaceholder: "Search released batch…",
          createNow: "Create batch now",
          empty: "No released batch found.",
          listTitle: "Select a released batch",
          change: "Change batch",
          toTicket: "The vouchers will be sent to this ticket.",
          numberLabel: "Customer number",
          numberInvalid: "Invalid number.",
          resultPdf: "Voucher sent as PDF.",
          resultLink: "Payment link sent.",
        },
        duration: {
          minutes: "{{count}} min",
          minutes_plural: "{{count}} min",
          hours: "{{count}} h",
          hours_plural: "{{count}} h",
          days: "{{count}} day",
          days_plural: "{{count}} days",
        },
        errors: {
          notConfigured: "Hotspot not configured.",
          unavailable: "Hotspot unavailable right now.",
          noLink: "No payment link available for this batch.",
        },
        devices: {
          table: {
            name: "Name",
            slug: "Slug",
            status: "Status",
            lastContact: "Last contact",
            vpn: "VPN",
            modes: "Access modes",
          },
          status: {
            online: "Online",
            offline: "Offline",
          },
          empty: "No devices found.",
          refresh: "Refresh",
        },
        payments: {
          filters: {
            status: "Status",
            device: "Device",
            allStatuses: "All",
            allDevices: "All",
            from: "From",
            to: "To",
          },
          status: {
            pago: "Paid",
            pendente: "Pending",
            expirado: "Expired",
          },
          table: {
            date: "Date",
            device: "Device",
            description: "Description",
            value: "Amount",
            status: "Status",
            gateway: "Gateway",
            noDevice: "No device",
            empty: "No payments found.",
          },
        },
        summary: {
          cards: {
            online: "Online now",
            leadsToday: "Leads today",
            leads7d: "Leads (7 days)",
            leads30d: "Leads (30 days)",
            paymentsPaid: "Paid payments",
            paymentsPending: "Pending payments",
            paymentsExpired: "Expired payments",
            revenue: "Revenue",
          },
          updatedAt: "Updated at {{time}}",
          empty: "No data available.",
        },
      },
      metaTemplates: {
        "title": "WhatsApp Templates",
        "list": {
          "connection": "Official connection",
          "search": "Search template…"
        },
        "buttons": {
          "sync": "Sync with Meta",
          "new": "New template",
          "edit": "Edit",
          "delete": "Delete"
        },
        "table": {
          "name": "Name",
          "category": "Category",
          "language": "Language",
          "status": "Status",
          "updatedAt": "Updated at",
          "actions": "Actions"
        },
        "empty": {
          "noConnectionTitle": "No official WhatsApp connection",
          "noConnection": "Add an official WhatsApp connection under Connections to create and manage Meta-approved templates.",
          "goToConnections": "Go to Connections",
          "noTemplates": "No templates yet. Click \"New template\" or \"Sync with Meta\".",
          "noResults": "No templates match your search."
        },
        "confirm": {
          "deleteTitle": "Delete template {{name}}?",
          "deleteMessage": "The template will be removed from Meta and from the system. Campaigns using it will stop working."
        },
        "toasts": {
          "synced": "Synced: {{total}} template(s) updated.",
          "deleted": "Template deleted.",
          "created": "Template submitted for Meta review.",
          "updated": "Edit submitted. The template is back in Meta review.",
          "saveError": "Could not save the template."
        },
        "status": {
          "APPROVED": "Approved",
          "PENDING": "Pending",
          "REJECTED": "Rejected",
          "PAUSED": "Paused",
          "noReason": "Meta did not provide a reason."
        },
        "category": {
          "MARKETING": "Marketing",
          "UTILITY": "Utility",
          "AUTHENTICATION": "Authentication"
        },
        "categoryHelp": {
          "MARKETING": "Promotions, offers and general announcements. Higher cost per conversation.",
          "UTILITY": "Billing, confirmations and order/service updates. Recommended for invoices.",
          "AUTHENTICATION": "Verification codes. Meta defines the text; use only for OTP."
        },
        "language": {
          "pt_BR": "Portuguese (Brazil)",
          "en_US": "English (US)",
          "es": "Spanish"
        },
        "parameterFormat": {
          "POSITIONAL": "Positional",
          "NAMED": "Named"
        },
        "headerFormat": {
          "NONE": "None",
          "TEXT": "Text",
          "IMAGE": "Image",
          "DOCUMENT": "Document",
          "VIDEO": "Video"
        },
        "preview": {
          "business": "Your business",
          "businessAccount": "Business account",
          "empty": "The message preview appears here as you fill in the form.",
          "document": "document.pdf",
          "copyCode": "Copy code",
          "buttonPlaceholder": "Button text",
          "seeAll": "See all options"
        },
        "editor": {
          "titleNew": "New template",
          "titleEdit": "Edit template {{name}}",
          "close": "Close",
          "cancel": "Cancel",
          "submit": "Submit for review",
          "saveEdit": "Save and resubmit",
          "metaError": "Meta rejected the template:",
          "editNotice": "Meta allows only one edit every 24 h; on save, the template goes back to review. Name and language cannot be changed.",
          "pendingNotice": "This template is still under review. Meta does not allow editing pending templates — wait for approval or rejection.",
          "previewTitle": "Preview",
          "insertVariable": "Insert variable",
          "variableName": "Variable name",
          "variableNameHelp": "Lowercase, digits and _ (e.g. name, due_date)",
          "insert": "Insert",
          "billingVariables": "Suggested billing variables (click to insert):",
          "examplesTitle": "Example for each variable (required for Meta approval)",
          "format": {
            "bold": "Bold",
            "italic": "Italic",
            "strike": "Strikethrough"
          },
          "sections": {
            "basic": "Identification",
            "basicHelp": "Unique name per connection, category and language. Meta uses the category for review and pricing.",
            "header": "Header (optional)",
            "headerHelp": "A short bold text or a media at the top of the message.",
            "body": "Body",
            "bodyHelp": "Main text. Use variables for name, amount, due date etc. and provide an example for each.",
            "footer": "Footer (optional)",
            "footerHelp": "Short gray line at the end of the message.",
            "buttons": "Buttons (optional)",
            "buttonsHelp": "Up to 10 buttons: quick reply, link, phone or copy code. Quick replies must be grouped together."
          },
          "fields": {
            "whatsapp": "Official connection",
            "name": "Template name",
            "nameHelp": "Automatically converted to lowercase with _ (e.g. billing_d3)",
            "nameLocked": "Meta does not allow renaming a submitted template",
            "category": "Category",
            "language": "Language",
            "parameterFormat": "Variable format",
            "headerFormat": "Header type",
            "headerText": "Header text",
            "headerTextHelp": "Up to 60 characters, at most one variable",
            "headerVarExample": "Example for header {{variable}}",
            "headerMediaExample": "Public sample URL",
            "headerMediaHelp": {
              "IMAGE": "Public link to a JPG/PNG image (Meta downloads it for review).",
              "DOCUMENT": "Public link to a sample PDF.",
              "VIDEO": "Public link to a sample MP4 video."
            },
            "body": "Message text",
            "bodyPlaceholder": "Hello! Your invoice is due soon. Use the Insert variable button to personalize.",
            "footer": "Footer text"
          },
          "buttons": {
            "count": "{{total}}/{{max}} buttons",
            "add": "Add button",
            "empty": "No buttons. Add quick replies or a link to pay the invoice.",
            "type": {
              "QUICK_REPLY": "Quick reply",
              "URL": "Open link",
              "PHONE_NUMBER": "Call",
              "COPY_CODE": "Copy code"
            },
            "moveUp": "Move up",
            "moveDown": "Move down",
            "remove": "Remove",
            "text": "Button text",
            "phone": "Phone",
            "phoneHelp": "With country code, e.g. +5531999999999",
            "url": "URL",
            "urlHelp": "May end with a variable for a dynamic link",
            "urlExample": "Full URL example",
            "urlExampleHelp": "Required when the URL has a variable",
            "copyCodeExample": "Sample code",
            "copyCodeHelp": "Coupon or code the customer copies"
          }
        },
        "validation": {
          "whatsappRequired": "Select the official WhatsApp connection.",
          "nameRequired": "Enter the template name.",
          "nameFormat": "The name may only contain lowercase letters, digits and _.",
          "categoryRequired": "Select the category.",
          "languageRequired": "Select the language.",
          "headerTextRequired": "Enter the header text or set the type to None.",
          "headerTextTooLong": "The header must have at most {{max}} characters.",
          "headerOneVariable": "The header accepts at most one variable.",
          "headerExampleRequired": "Provide an example for the header variable.",
          "headerMediaExampleRequired": "Provide a public (http/https) sample URL for the header media.",
          "bodyRequired": "Enter the message text.",
          "bodyTooLong": "The body must have at most {{max}} characters.",
          "bodyExampleRequired": "Provide an example for: {{vars}}.",
          "namedVariableFormat": "Invalid variable name ({{vars}}): use lowercase letters, digits and _, starting with a letter.",
          "positionalSequence": "Positional variables must be numbered sequentially from 1 with no gaps.",
          "footerTooLong": "The footer must have at most {{max}} characters.",
          "tooManyButtons": "At most {{max}} buttons.",
          "tooManyUrlButtons": "At most {{max}} link buttons.",
          "tooManyPhoneButtons": "Only one phone button is allowed.",
          "tooManyCopyCodeButtons": "Only one copy-code button is allowed.",
          "buttonsGrouped": "Quick reply buttons must be grouped together (all before or all after the others).",
          "buttonTextRequired": "Button {{n}}: enter the text.",
          "buttonTextTooLong": "Button {{n}}: the text must have at most {{max}} characters.",
          "buttonTextDuplicate": "Button {{n}}: another button already has this text.",
          "buttonUrlInvalid": "Button {{n}}: enter a valid URL starting with http:// or https://.",
          "buttonUrlVariable": "Button {{n}}: the URL may have only one variable, and it must be at the end.",
          "buttonUrlExampleRequired": "Button {{n}}: provide a full URL example.",
          "buttonPhoneInvalid": "Button {{n}}: enter a valid phone with country code (e.g. +5531999999999).",
          "buttonCopyCodeRequired": "Button {{n}}: enter the sample code.",
          "buttonCopyCodeTooLong": "Button {{n}}: the code must have at most {{max}} characters."
        }
      },
      invoiceCampaigns: {
        details: {
          of: "of",
          open: "View details",
          searchPlaceholder: "Search by name, number, contract, invoice or tax ID",
          filters: {
            all: "All",
            sent: "Sent",
            failed: "Failed",
            skipped: "Skipped",
            pending: "Pending",
          },
          columns: {
            customer: "Customer",
            contract: "Contract",
            invoice: "Invoice",
            dueDate: "Due date",
            amount: "Amount",
            number: "Number",
            otherNumbers: "Other numbers",
            result: "Result",
            reason: "Reason",
            sentAt: "Sent at",
          },
          status: {
            sent: "Sent",
            failed: "Failed",
            pending: "Pending",
            skipped_optout: "Skipped",
            skipped_dedup: "Skipped",
            skipped_needs_template: "Skipped",
            skipped_no_phone: "Skipped",
            skipped_cancelled: "Cancelled",
          },
          reason: {
            skipped_optout: "Customer opted out",
            skipped_dedup: "This invoice was already sent recently",
            skipped_needs_template: "Official channel requires an approved template",
            skipped_no_phone: "No phone in the ERP",
            skipped_cancelled: "Campaign cancelled before sending",
          },
          alsoTried: "Alternative:",
          empty: "No sends found.",
          export: "Export to Excel",
          exporting: "Exporting...",
          sheetName: "Sends",
          close: "Close",
        },
        filters: {
          overdue: "Overdue",
          upcoming: "Upcoming",
          alert: "Outage notice",
        },
        title: "Invoice Campaigns",
        form: {
          name: "Campaign name",
          whatsapp: "WhatsApp connection",
          erpIntegration: "ERP integration",
          filter: "Invoice filter",
          filterOverdue: "Overdue",
          filterUpcoming: "Due soon",
          daysAhead: "Days until due date",
          template: "Message (template)",
          variablesHelp: "Available variables (click to insert):",
          scheduledAt: "Schedule for (optional)",
          scheduledAtHelp: "Leave blank to send immediately",
          metaTemplateName: "Meta template name",
          metaTemplateNameHelp: "Required for official WhatsApp connections",
          none: "None",
          defaultTemplate: "Hello {nome}! Your invoice for contract {contrato} of {valor} is due on {vencimento}.\nBarcode: {linhaDigitavel}\nPIX copy & paste: {pix}\nInvoice: {link}",
        },
        buttons: {
          preview: "Preview",
          createAndSend: "Create and send",
          cancel: "Cancel campaign",
          close: "Close",
        },
        preview: {
          title: "Campaign preview",
          total: "Total to send",
          optout: "Opt-out",
          dedup: "Already sent (7 days)",
          needsTemplate: "Missing Meta template",
          samples: "Sample messages",
          noSamples: "No samples returned for the selected filters.",
        },
        table: {
          type: "Type",
          name: "Name",
          status: "Status",
          pending: "Pending",
          sent: "Sent",
          failed: "Failed",
          skipped: "Skipped",
          createdAt: "Created at",
          actions: "Actions",
          empty: "No invoice campaigns created yet.",
        },
        status: {
          pending: "Pending",
          scheduled: "Scheduled",
          running: "Running",
          processing: "Running",
          finished: "Finished",
          completed: "Finished",
          cancelled: "Cancelled",
          canceled: "Cancelled",
          failed: "Failed",
        },
        validation: {
          nameRequired: "Enter the campaign name.",
          whatsappRequired: "Select the WhatsApp connection.",
          erpRequired: "Select the ERP integration.",
          templateRequired: "Enter the campaign message.",
          daysAheadInvalid: "Days until due date must be an integer greater than or equal to zero.",
          metaTemplateRequired: "Enter the Meta template name for official connections.",
        },
        toasts: {
          created: "Invoice campaign created successfully.",
          cancelled: "Campaign cancelled.",
        },
        confirmationModal: {
          cancelTitle: "Cancel campaign",
          cancelMessage: "Pending sends will be stopped. This action cannot be undone.",
        },
      },
      queueIntegrationModal: {
        types: {
          SGP: "ERP SGP",
          IXC: "ERP IXC",
          ASAAS: "Asaas (billing)",
          ISP_IA: "Support AI (ISP)",
          HOTSPOT: "Hotspot (Seu Hotspot)",
          HOSPEDAGEM_CONECTOR: "Lodging connector (website)",
          HOSPEDAGEM_IA: "Lodging Agent",
        },
        title: {
          add: "Add Project",
          edit: "Edit Project",
        },
        form: {
          tipoIntegracao: "Integration type",
          sgpIeSenha: "User provides password",
          sgpUrl: "SGP URL",
          sgpWidePayToken: "Widepay Token",
          sgpApp: "App (URA integration)",
          sgpToken: "App token",
          sgpTokenToggle: "Show/hide token",
          sgpMode: "Mode",
          sgpModeHelp: "App + Token are registered in SGP (Integrations → URA). With them the system looks customers up by CPF without asking for the subscriber password and enables invoice campaigns and the support AI on SGP. Leave blank to use only the subscriber portal.",
          ixcUrl: "IXC base URL",
          asaasApiKey: "Asaas API key",
          asaasEnvironment: "Asaas environment",
          asaasHelp: "Create the key in Asaas → Integrations → API key. Use Sandbox to test. Asaas covers customer, charges, bank slip, digitable line and PIX; no internet contract, unlock or connection status.",
          ixcToken: "IXC API token",
          timeoutMs: "Timeout (ms) — optional",
          erpIntegrationId: "ERP integration",
          openaiApiKey: "OpenAI API key",
          model: "Model",
          handoffQueueId: "Handoff queue",
          receiptQueueId: "Receipt queue (photo/PDF)",
          receiptQueueKeep: "Keep current queue",
          receiptQueueIdHelp: "When an identified customer sends a photo or PDF during the chatbot, the file is read by AI as a payment receipt, checked against open invoices, and the ticket goes to this queue with an internal note.",
          maxTurns: "Max turns",
          promptExtra: "Extra provider instructions",
          promptExtraHelp: "Text appended to the AI prompt (hours, policies, tone of voice, etc.)",
          none: "None",
          id: "ID",
          type: "Type",
          name: "Name",
          projectName: "Project Name",
          language: "Language",
          jsonContent: "JSON Content",
          urlN8N: "URL",
          typebotSlug: "Typebot - Slug",
          typebotExpires: "Expiration time in minutes",
          typebotKeywordFinish: "Keyword to finish the ticket",
          typebotKeywordRestart: "Keyword to restart the flow",
          typebotRestartMessage: "Message when restarting the conversation",
          typebotUnknownMessage: "Invalid option message",
          typebotDelayMessage: "Delay (ms) between messages",
          hotspotBaseUrl: "Hotspot URL",
          hotspotApiKey: "API key",
          hotspotTest: "Test connection",
          hotspotDefaultDevice: "Default device",
          hotspotDefaultTabela: "Default price table",
          hotspotHelp: "Generate the key in the hotspot panel under Settings → Integrations.",
          hospedagemProvider: "Provider",
          hospedagemBaseUrl: "Site URL",
          hospedagemApiKey: "API key",
          hospedagemTest: "Test connection",
          hospedagemPropostaHabilitada: "Site accepts proposals from the agent (turn on only after the site is published)",
          hospedagemPropostaHabilitadaHelp:
            "Off: the agent closes with a pre-booking, as always. Turn on only after the site has the proposals route published; then the agent generates the proposal link, quotes the card price and follows the sales script.",
          hospedagemIntegrationId: "Lodging connector",
          openaiApiKeyOptionalHelp: "Empty = uses the platform key.",
          nomeAgente: "Agent name",
          nomeEmpresa: "Company name",
          persona: "Agent persona",
          personaHelp: "Instructions for the agent: who it is, tone, rules — the text it follows in the conversation.",
          permitirPreReserva: "Allow creating pre-reservations",
          pedirEmailParaReserva: "Ask for email to reserve",
          voiceMode: "Voice reply",
          voiceModeHelp: "When the agent replies with a voice note",
          voiceModeMirror: "When the customer sends audio (default)",
          voiceModeAlways: "Whenever possible",
          voiceModeOff: "Never (text only)",
          voice: "Voice (OpenAI TTS)",
        },
        hospedagem: {
          vendaTitle: "Sales and greeting",
          responderPrimeiraMensagem: "Reply to the customer's first message",
          responderPrimeiraMensagemHelp: "When on, the agent answers what the customer already wrote (source ad, question) instead of the fixed greeting. If it is just a hello, the fixed greeting is kept.",
          fichaEmpresa: "Company fact sheet",
          fichaEmpresaHelp: "Fixed facts the AI may quote: address, house rules, check-in and check-out times, pets, parking etc.",
          escadaTitle: "Concession ladder",
          escadaHelp: "Conditions the AI may offer, one at a time and in this order, when the customer hesitates on price (up to 4). Only used when the connector site supports proposals; in high season and holidays the AI offers no special condition.",
          escadaEmpty: "No steps: the AI offers no special condition.",
          addDegrau: "Add step",
          degrauN: "Step {{n}}",
          moveUp: "Move up",
          moveDown: "Move down",
          remove: "Remove",
          tipo: "Condition",
          tipoSelect: "Choose the condition",
          tipos: {
            ISENTAR_LIMPEZA: "Waive cleaning fee",
            INCLUIR_EXTRA: "Include extra service",
            DESCONTO_PCT: "Discount %",
            NOITE_EXTRA: "Extra night with discount",
          },
          pctDesconto: "Discount (%)",
          pctNoite: "Extra night discount (%)",
          pctHelp: "Whole number from 1 to {{max}}.",
          servicoExtraNome: "Extra service",
          servicoExtraNomeHelp: "Name of the extra service exactly as on the site.",
          frase: "How the AI presents it",
          fraseHelp: "Sentence the AI uses to offer this condition to the customer.",
          periodosTitle: "Periods without ladder (high season)",
          periodosHelp: "Stays with any night in these periods get no special condition.",
          periodosEmpty: "No periods.",
          addPeriodo: "Add period",
          periodoN: "Period {{n}}",
          rotulo: "Period name",
          rotuloHelp: "E.g. New Year, July holidays.",
          anual: "Repeats every year",
          anualOnHelp: "Dates as DD/MM.",
          anualOffHelp: "Only on the chosen dates (with year).",
          sim: "Yes",
          nao: "No",
          inicio: "Start",
          fim: "End",
          incluirFeriadosNacionais: "National holidays and Carnival also without ladder",
          incluirFeriadosHelp: "Blocks the ladder on the long weekend of each national holiday and on Carnival.",
          errors: {
            fixFields: "Fix the concession ladder and periods without ladder fields.",
            tipoRequired: "Choose the condition.",
            maxDegraus: "At most 4 steps: remove this one.",
            pctDesconto: "Enter a whole number from 1 to 10.",
            pctNoite: "Enter a whole number from 1 to 50.",
            extraRequired: "Enter the extra service name.",
            fraseRequired: "Write how the AI presents this condition.",
            rotuloRequired: "Name the period.",
            diaMesInvalid: "Invalid date (use DD/MM).",
            dataInvalid: "Invalid date.",
            fimAntesInicio: "End must be on or after start.",
          },
        },
        buttons: {
          testErp: "Test connection",
          testErpSaveFirst: "Save the integration first to test the connection",
          okAdd: "Add",
          okEdit: "Save",
          cancel: "Cancel",
          test: "Test Bot",
        },
        messages: {
          erpHealthOk: "ERP connection OK",
          erpHealthFail: "ERP connection failed",
          testSuccess: "Integration tested successfully!",
          addSuccess: "Integration added successfully.",
          editSuccess: "Integration edited successfully.",
          hotspotTestOk: "Connected to tenant {{name}}",
          hospedagemTestOk: "Connection to the site OK",
        },
      },
      userModal: {
        warning: "To import messages, you must scan the QR Code again!",
        title: {
          add: "Add User",
          edit: "Edit User",
          updateImage: "Update Image",
          removeImage: "Delete Image",
        },
        form: {
          name: "Name",
          email: "Email",
          password: "Password",
          farewellMessage: "Farewell Message",
          profile: "Profile",
          startWork: "Work Start Time",
          endWork: "Work End Time",
          whatsapp: "Default Connection",
          allTicketEnable: "Enabled",
          allTicketDisable: "Disabled",
          allTicket: "View Tickets Without Queue",
          allowGroup: "Allow Groups",
          defaultMenuOpen: "Open",
          defaultMenuClosed: "Closed",
          defaultMenu: "Default Menu",
          defaultTheme: "Default Theme",
          defaultThemeDark: "Dark",
          defaultThemeLight: "Light",
          allHistoric: "View Conversations from Other Queues",
          allHistoricEnabled: "Enabled",
          allHistoricDisabled: "Disabled",
          allUserChat: "View Other Users' Conversations",
          userClosePendingTicket: "Allow Closing Pending Tickets",
          showDashboard: "View Dashboard",
          allowRealTime: "View Real-Time Panel",
          allowConnections: "Allow Actions on Connections",
          showContacts: "View Contacts",
          showCampaign: "View Campaigns",
          allowedWhatsapps: "Connections this user can handle",
          allowedWhatsappsAll: "All",
          allowedWhatsappsHelp: "None selected = all. With connections selected, the user only sees, opens and replies to their conversations.",
        },
        tabs: {
          general: "General",
          permissions: "Permissions",
        },
        buttons: {
          okAdd: "Add",
          okEdit: "Save",
          cancel: "Cancel",
          addImage: "Add Image",
          editImage: "Edit Image",
        },
        success: "User saved successfully.",
      },
      companyModal: {
        title: {
          add: "Add Company",
          edit: "Edit Company",
        },
        form: {
          name: "Name",
          email: "Email",
          passwordDefault: "Password",
          numberAttendants: "Users",
          numberConections: "Connections",
        },
        buttons: {
          okAdd: "Add",
          okEdit: "Save",
          cancel: "Cancel",
        },
        success: "Company saved successfully.",
      },
      scheduleModal: {
        title: {
          add: "New Schedule",
          edit: "Edit Schedule",
          message: "Message",
        },
        form: {
          body: "Message",
          contact: "Contact",
          sendAt: "Scheduled Date",
          sentAt: "Sent Date",
          assinar: "Send Signature",
        },
        buttons: {
          okAdd: "Add",
          okEdit: "Save",
          cancel: "Cancel",
          addSchedule: "Add Schedule",
        },
        success: "Schedule saved successfully.",
      },
      tagModal: {
        title: {
          add: "New Tag",
          edit: "Edit Tag",
          addKanban: "New Lane",
          editKanban: "Edit Lane",
          backToKanban: "BACK TO KANBAN",
        },
        form: {
          name: "Name",
          color: "Color",
          timeLane: "Time in minutes to redirect to lane",
          nextLaneId: "Lane",
          greetingMessageLane: "Lane Greeting Message",
          mediaFiles: "Media",
          rollbackLaneId: "Return to Lane after resuming attendance",
        },
        buttons: {
          okAdd: "Add",
          okEdit: "Save",
          cancel: "Cancel",
        },
        success: "Tag saved successfully.",
        successKanban: "Lane saved successfully.",
      },
      fileModal: {
        title: {
          add: "Add File List",
          edit: "Edit File List",
        },
        buttons: {
          okAdd: "Save",
          okEdit: "Edit",
          cancel: "Cancel",
          fileOptions: "Add File",
        },
        form: {
          name: "File List Name",
          message: "List Details",
          fileOptions: "File List",
          extraName: "Message to send with file",
          extraValue: "Option Value",
        },
        success: "File list saved successfully!",
      },
      chat: {
        noTicketMessage: "Select a ticket to start chatting.",
      },
      uploads: {
        titles: {
          titleUploadMsgDragDrop: "⬇️ DRAG AND DROP FILES BELOW ⬇️",
          titleFileList: "File List",
        },
      },
      chatInternal: {
        new: "New group",
        modal: {
          conversation: "Conversation",
          title: "Title",
          filterUsers: "Filter by Users",
          cancel: "Close",
          save: "Save",
        },
        modalDelete: {
          title: "Delete Conversation",
          message: "This action cannot be undone, confirm?",
        },
      },
      ticketsManager: {
        questionCloseTicket: "DO YOU WANT TO CLOSE ALL TICKETS?",
        yes: "YES",
        not: "NO",
        buttons: {
          newTicket: "New",
          resolveAll: "Resolve All",
          close: "Close",
          new: "New",
        },
      },
      ticketsQueueSelect: {
        placeholder: "Queues",
      },
      tickets: {
        inbox: {
          closedAllTickets: "Close all tickets?",
          closedAll: "Close All",
          newTicket: "New Ticket",
          yes: "YES",
          no: "NO",
          open: "Open",
          pending: "Pending",
          closed: "Closed",
          resolverd: "Resolved",
        },
        toasts: {
          deleted: "The attendance you were handling has been deleted.",
        },
        notification: {
          message: "Message from",
        },
        tabs: {
          open: { title: "Open" },
          closed: { title: "Resolved" },
          search: { title: "Search" },
        },
        search: {
          placeholder: "Search attendance and messages",
          filterConections: "Filter by Connection",
          filterConectionsOptions: {
            open: "Open",
            closed: "Closed",
            pending: "Pending",
          },
          filterUsers: "Filter by Users",
          filterContacts: "Filter by Contacts",
          ticketsPerPage: "Tickets per page",
        },
        buttons: {
          showAll: "All",
          returnQueue: "Return to Queue",
          scredule: "Schedule",
          deleteTicket: "Delete Ticket",
        },
        closedTicket: {
          closedMessage: "Close Ticket With Farewell Message",
          closedNotMessage: "Close Ticket Without Farewell Message",
        },
      },
      transferTicketModal: {
        title: "Transfer Ticket",
        fieldLabel: "Type to search for users",
        fieldQueueLabel: "Transfer to Queue",
        fieldQueuePlaceholder: "Select a queue",
        fieldWhatsapp: "Select a WhatsApp",
        noOptions: "No users found with that name",
        msgTransfer: "Notes - internal message, will not be sent to the client",
        buttons: {
          ok: "Transfer",
          cancel: "Cancel",
        },
      },
      chatInternal: {
        new: "New group",
        modal: {
          conversation: "Conversation",
          title: "Title",
          filterUsers: "Filter by Users",
          cancel: "Close",
          save: "Save",
        },
        modalDelete: {
          title: "Delete Conversation",
          message: "This action cannot be undone, confirm?",
        },
      },
      ticketsList: {
        called: "Call",
        today: "Today",
        missedCall: "Missed voice/video call at",
        pendingHeader: "Waiting",
        assignedHeader: "In Attendance",
        groupingHeader: "Groups",
        status: {
          open: "In progress",
          pending: "Waiting",
          closed: "Completed",
          group: "Group",
        },
        noTicketsTitle: "Nothing here!",
        noTicketsMessage:
          "No attendances found with this status or search term",
        noQueue: "No Queue",
        buttons: {
          accept: "Accept",
          cancel: "Cancel",
          start: "Start",
          closed: "Close",
          reopen: "Reopen",
          transfer: "Transfer",
          ignore: "Ignore",
          exportAsPDF: "Export to PDF",
          kanbanActions: "Kanban Options",
        },
        acceptModal: {
          title: "Accept Chat",
          queue: "Select Sector",
        },
      },
      newTicketModal: {
        title: "Create Ticket",
        fieldLabel: "Type to search for a contact",
        add: "Add",
        connectionRequired: "Select a connection",
        buttons: {
          ok: "Save",
          cancel: "Cancel",
        },
      },
      SendContactModal: {
        title: "Send Contact",
        fieldLabel: "Type to search for contact",
        add: "Add",
        buttons: {
          ok: "Send",
          cancel: "Cancel",
        },
      },
      mainDrawer: {
        listItems: {
          channelsGroup: "Channels and API",
          searchMenu: "Search menu…",
          phraseLists: "Phrase lists",
          flowbuilders: "Conversation flows",
          platform: "Platform",
          configGroup: "Administration",
          automation: "Automation",
          billingGroup: "Billing & ISP",
          attendance: "Service",
          networkAlerts: "Outage Alerts",
          hotspot: "Hotspot",
          aiPlatform: "Platform AI",
          systemResources: "Server",
          dashboard: "Dashboard",
          connections: "Communication channels",
          chatsTempoReal: "Real-time panel",
          supervision: "Supervision",
          ratings: "Ratings",
          tickets: "Attendances",
          quickMessages: "Quick Replies",
          contacts: "Contacts",
          wallets: "Wallets",
          queues: "Service queues",
          tags: "Tags",
          administration: "Administration",
          companies: "Companies",
          users: "Team and users",
          birthdaySettings: "Birthdays",
          settings: "System preferences",
          files: "Files",
          helps: "Help Center",
          messagesAPI: "API and integrations",
          schedules: "Schedules",
          campaigns: "Campaigns",
          annoucements: "Announcements",
          chats: "Internal Chat",
          financeiro: "Financial",
          resellerFinance: "Reseller finance",
          queueIntegration: "Integrations",
          version: "Version",
          kanban: "Kanban",
          prompts: "AI prompts",
          aiLearning: "AI learning",
          allConnections: "Manage Connections",
          reports: "Reports",
          management: "Management",
        },
        appBar: {
          user: {
            profile: "Profile",
            logout: "Logout",
            message: "Hello",
            messageEnd: "welcome to",
            active: "Active until",
            goodMorning: "Hi,",
            myName: "my name is",
            continuity: "and I will continue your service.",
            virtualAssistant: "Virtual Assistant",
            token: "Invalid token, please contact the platform administrator.",
          },
          message: {
            location: "Location",
            contact: "Contact",
          },
          notRegister: "No records found",
          refresh: "Refresh",
        },
      },
      languages: {
        undefined: "Language",
        "pt-BR": "Portuguese",
        es: "Spanish",
        en: "English",
        tr: "Turkish",
      },
      messagesAPI: {
        title: "API",
        toSend: "TO SEND",
        textMessage: {
          number: "Number",
          body: "Message",
          token: "Registered Token",
          userId: "User/Agent ID",
          queueId: "Queue ID",
        },
        mediaMessage: {
          number: "Number",
          body: "File Name",
          media: "File",
          token: "Registered Token",
        },
        API: {
          title: "Message Sending Documentation",
          methods: {
            title: "Sending Methods",
            messagesText: "Text Messages",
            messagesMidia: "Media Messages",
          },
          instructions: {
            title: "Instructions",
            comments: "Important Notes",
            comments1:
              "Before sending messages, it is necessary to register the token linked to the connection that will send the messages. <br />To register, access the 'Connections' menu, click the edit button on the connection, and insert the token in the appropriate field.",
            comments2:
              "The sending number must not have a mask or special characters and must be composed of:",
            codeCountry: "Country Code",
            code: "Area Code (DDD)",
            number: "Phone Number",
          },
          text: {
            title: "1. Text Messages",
            instructions:
              "Below is the list of required information to send text messages:",
          },
          media: {
            title: "2. Media Messages",
            instructions:
              "Below is the list of required information to send media messages:",
          },
        },
      },
      notifications: {
        noTickets: "No notifications.",
      },
      quickMessages: {
        title: "Quick Replies",
        searchPlaceholder: "Search...",
        noAttachment: "No attachment",
        confirmationModal: {
          deleteTitle: "Delete",
          deleteMessage: "This action is irreversible! Do you want to proceed?",
        },
        buttons: {
          add: "Add",
          attach: "Attach File",
          cancel: "Cancel",
          edit: "Edit",
        },
        toasts: {
          success: "Shortcut added successfully!",
          deleted: "Shortcut removed successfully!",
        },
        dialog: {
          title: "Quick Message",
          shortcode: "Shortcut",
          message: "Response",
          save: "Save",
          cancel: "Cancel",
          general: "General",
          geral: "Allow Editing",
          add: "Add",
          edit: "Edit",
          visao: "Allow Viewing",
        },
        table: {
          shortcode: "Shortcut",
          message: "Message",
          actions: "Actions",
          mediaName: "File Name",
          status: "Status",
        },
      },
      contactLists: {
        title: "Contact Lists",
        table: {
          name: "Name",
          contacts: "Contacts",
          actions: "Actions",
        },
        buttons: {
          add: "New List",
        },
        dialog: {
          name: "Name",
          company: "Company",
          okEdit: "Edit",
          okAdd: "Add",
          add: "Add",
          edit: "Edit",
          cancel: "Cancel",
        },
        confirmationModal: {
          deleteTitle: "Delete",
          deleteMessage: "This action cannot be undone.",
        },
        toasts: {
          deleted: "Record deleted successfully.",
        },
      },
      contactListItems: {
        title: "Contacts",
        searchPlaceholder: "Search",
        buttons: {
          add: "New",
          lists: "Lists",
          import: "Import",
        },
        dialog: {
          name: "Name",
          number: "Number",
          whatsapp: "WhatsApp",
          email: "Email",
          okEdit: "Edit",
          okAdd: "Add",
          add: "Add",
          edit: "Edit",
          cancel: "Cancel",
        },
        table: {
          name: "Name",
          number: "Number",
          whatsapp: "WhatsApp",
          email: "Email",
          actions: "Actions",
        },
        confirmationModal: {
          deleteTitle: "Delete",
          deleteMessage: "This action cannot be undone.",
          importMessage:
            "Do you want to import the contacts from this spreadsheet?",
          importTitlte: "Import",
        },
        toasts: {
          deleted: "Record deleted successfully.",
        },
      },
      kanban: {
        title: "Kanban",
        searchPlaceholder: "Search",
        subMenus: {
          list: "Board",
          tags: "Lanes",
        },
      },
      campaigns: {
        title: "Campaigns",
        searchPlaceholder: "Search",
        subMenus: {
          invoiceCampaigns: "Invoice Campaigns",
          metaTemplates: "WhatsApp Templates",
          billingRules: "Billing reminders",
          list: "Listing",
          listContacts: "Contact List",
          settings: "Settings",
        },
        settings: {
          randomInterval: "Random Sending Interval",
          noBreak: "No Interval",
          intervalGapAfter: "Longer interval after",
          undefined: "Undefined",
          messages: "messages",
          laggerTriggerRange: "Larger Sending Interval",
          addVar: "Add Variable",
          save: "Save",
          close: "Close",
          add: "Add",
          shortcut: "Shortcut",
          content: "Content",
        },
        buttons: {
          add: "New Campaign",
          contactLists: "Contact Lists",
        },
        table: {
          name: "Name",
          whatsapp: "Connection",
          contactList: "Contact List",
          option: "None",
          disabled: "Disabled",
          enabled: "Enabled",
          status: "Status",
          scheduledAt: "Scheduled",
          completedAt: "Completed",
          confirmation: "Confirmation",
          actions: "Actions",
        },
        dialog: {
          new: "New Campaign",
          update: "Edit Campaign",
          readonly: "View Only",
          help: "Use variables like {name}, {number}, {email}, or define custom variables.",
          form: {
            name: "Name",
            message1: "Message 1",
            message2: "Message 2",
            message3: "Message 3",
            message4: "Message 4",
            message5: "Message 5",
            confirmationMessage1: "Confirmation Message 1",
            confirmationMessage2: "Confirmation Message 2",
            confirmationMessage3: "Confirmation Message 3",
            confirmationMessage4: "Confirmation Message 4",
            confirmationMessage5: "Confirmation Message 5",
            messagePlaceholder: "Message content",
            whatsapp: "Connection",
            status: "Status",
            scheduledAt: "Schedule",
            confirmation: "Confirmation",
            contactList: "Contact List",
            tagList: "Tags",
            statusTicket: "Ticket Status",
            openTicketStatus: "Open",
            pendingTicketStatus: "Pending",
            closedTicketStatus: "Closed",
            enabledOpenTicket: "Enabled",
            disabledOpenTicket: "Disabled",
            openTicket: "Open Ticket",
          },
          buttons: {
            add: "Add",
            edit: "Update",
            okadd: "Ok",
            cancel: "Cancel Sending",
            restart: "Restart Sending",
            close: "Close",
            attach: "Attach File",
          },
        },
        confirmationModal: {
          deleteTitle: "Delete",
          deleteMessage: "This action cannot be undone.",
        },
        toasts: {
          success: "Operation completed successfully.",
          cancel: "Campaign canceled.",
          restart: "Campaign restarted.",
          deleted: "Record deleted successfully.",
        },
      },
      campaignReport: {
        title: "Campaign Report",
        inactive: "Inactive",
        scheduled: "Scheduled",
        process: "In Progress",
        cancelled: "Canceled",
        finished: "Completed",
        campaign: "Campaign",
        validContacts: "Valid Contacts",
        confirmationsRequested: "Confirmations Requested",
        confirmations: "Confirmations",
        deliver: "Delivered",
        connection: "Connection",
        contactLists: "Contact List",
        schedule: "Schedule",
        conclusion: "Conclusion",
      },
      announcements: {
        title: "Announcements",
        searchPlaceholder: "Search",
        active: "Active",
        inactive: "Inactive",
        buttons: {
          add: "New Announcement",
          contactLists: "Announcement Lists",
        },
        table: {
          priority: "Priority",
          title: "Title",
          text: "Text",
          mediaName: "File",
          status: "Status",
          actions: "Actions",
        },
        dialog: {
          edit: "Edit Announcement",
          add: "New Announcement",
          update: "Edit Announcement",
          readonly: "View Only",
          form: {
            priority: "Priority",
            title: "Title",
            text: "Text",
            mediaPath: "File",
            status: "Status",
            high: "High",
            medium: "Medium",
            low: "Low",
            active: "Active",
            inactive: "Inactive",
          },
          buttons: {
            add: "Add",
            edit: "Update",
            okadd: "Ok",
            cancel: "Cancel",
            close: "Close",
            attach: "Attach File",
          },
        },
        confirmationModal: {
          deleteTitle: "Delete",
          deleteMessage: "This action cannot be undone.",
        },
        toasts: {
          success: "Operation completed successfully.",
          deleted: "Record deleted successfully.",
        },
      },
      campaignsConfig: {
        title: "Campaign Settings",
      },
      queues: {
        title: "Queues & Chatbot",
        table: {
          name: "Name",
          color: "Color",
          greeting: "Greeting Message",
          orderQueue: "Queue Order (Bot)",
          actions: "Actions",
          ID: "ID",
        },
        buttons: {
          add: "Add Queue",
        },
        toasts: {
          success: "Queue saved successfully.",
          deleted: "Queue deleted successfully.",
        },
        confirmationModal: {
          deleteTitle: "Delete",
          deleteMessage:
            "Are you sure? This action cannot be undone! Attendances from this queue will still exist but will no longer be assigned to a queue.",
        },
      },
      queue: {
        queueData: "Queue Data",
      },
      queueSelect: {
        inputLabel: "Queues",
        inputLabelRO: "Read-Only Queues",
        withoutQueue: "No Queue",
      },
      reports: {
        title: "Attendance Reports",
        startDate: "Start date ",
        endDate: "End date",

        table: {
          id: "Ticket",
          user: "User",
          dateOpen: "Opening Date",
          dateClose: "Closing Date",
          NPS: "NPS",
          status: "Status",
          whatsapp: "Connection",
          queue: "Queue",
          actions: "Actions",
          lastMessage: "Last Message",
          contact: "Customer",
          supportTime: "Attendance Time",
        },
        buttons: {
          filter: "Apply Filter",
          onlyRated: "Only Rated",
        },
        searchPlaceholder: "Search...",
      },
      queueIntegration: {
        title: "Integrations",
        table: {
          id: "ID",
          type: "Type",
          name: "Name",
          projectName: "Project Name",
          language: "Language",
          lastUpdate: "Last Update",
          actions: "Actions",
        },
        buttons: {
          add: "Add Project",
        },
        searchPlaceholder: "Search...",
        confirmationModal: {
          deleteTitle: "Delete",
          deleteMessage:
            "Are you sure? This action cannot be undone and will be removed from linked queues and connections.",
        },
      },
      users: {
        title: "Users",
        table: {
          status: "Status",
          name: "Name",
          email: "Email",
          profile: "Profile",
          startWork: "Work Start Time",
          endWork: "Work End Time",
          actions: "Actions",
          ID: "ID",
        },
        buttons: {
          add: "Add User",
        },
        toasts: {
          deleted: "User deleted successfully.",
        },
        confirmationModal: {
          deleteTitle: "Delete",
          deleteMessage:
            "All user data will be lost. Open tickets for this user will be moved to the queue.",
        },
      },
      resellerFinance: {
        title: "Finance",
        subtitlePlatform: "Platform revenue: direct companies and resellers",
        subtitleReseller: "Revenue from your companies and your invoice with the platform",
        month: "Month",
        stats: {
          receivable: "Receivable",
          paid: "Received",
          overdue: "Overdue",
          mrr: "MRR",
          mrrHint: "Sum of active companies' plans",
          payable: "My invoice",
          dueOn: "Due on",
          noPayable: "No open invoice",
          invoices: "invoices",
          companies: "companies",
          delinquentCompanies: "delinquent companies",
          noOverdue: "All settled",
        },
        status: { open: "Open", paid: "Paid", overdue: "Overdue", none: "No invoice" },
        delinquent: { title: "Delinquent", hint: "Open invoices past their due date" },
        byCompany: { title: "By company" },
        byPlan: { title: "By plan", hint: "Active companies × plan amount" },
        table: {
          company: "Company",
          plan: "Plan",
          value: "Amount",
          dueDate: "Due date",
          lastInvoice: "Last invoice",
          overdueDays: "Days overdue",
          days: "days",
          actions: "Actions",
          companies: "Companies",
          amount: "Amount",
          mrr: "MRR",
          inactive: "Inactive",
        },
        actions: { invoices: "Invoices", company: "Company" },
        empty: {
          title: "No companies yet",
          message: "Create companies to track invoices, overdue payments and MRR here.",
          action: "Create company",
        },
      },
      invite: {
        title: "Invite",
        loading: "Checking invite...",
        invitedTo: "You have been invited to",
        instruction: "Set your password to get started.",
        form: {
          email: "E-mail",
          name: "Your name",
          namePlaceholder: "How you want to be called",
          password: "Password",
          passwordHelper: "At least {{min}} characters",
          confirm: "Confirm password",
        },
        buttons: { submit: "Create access and sign in" },
        alreadyHaveAccount: "Already have access? Sign in",
        goToLogin: "Go to login",
        errors: {
          passwordMin: "Password must have at least {{min}} characters.",
          passwordMismatch: "Passwords do not match.",
        },
        toasts: { accepted: "Access created! Welcome." },
        notFound: { title: "Invite not found", message: "This link is invalid or was already used. Ask your provider for a new invite." },
        expired: { title: "Invite expired", message: "This invite is past its validity. Ask your provider for a new invite." },
        generic: { title: "Could not open the invite", message: "Try again in a moment. If it persists, ask for a new invite." },
      },
      onboarding: {
        title: "Getting started",
        subtitle: "Complete these steps to start serving customers.",
        hide: "Hide",
        progress: "done",
        items: {
          connection: { title: "Connect WhatsApp", hint: "Scan the QR code or connect the official API" },
          queue: { title: "Create a queue", hint: "Organize tickets by department" },
          team: { title: "Invite your team", hint: "Add at least one more user" },
          quickMessage: { title: "Create a quick reply", hint: "Speed up frequent answers" },
        },
      },
      compaies: {
        title: "Companies",
        table: {
          ID: "ID",
          status: "Active",
          name: "Name",
          email: "Email",
          password: "Password",
          phone: "Phone",
          plan: "Plan",
          active: "Active",
          numberAttendants: "Agents",
          numberConections: "Connections",
          value: "Value",
          namePlan: "Plan Name",
          numberQueues: "Queues",
          useCampaigns: "Campaigns",
          useExternalApi: "REST API",
          useFacebook: "Facebook",
          useInstagram: "Instagram",
          useWhatsapp: "WhatsApp",
          useInternalChat: "Internal Chat",
          useSchedules: "Scheduling",
          createdAt: "Created At",
          dueDate: "Expiration Date",
          lastLogin: "Last Login",
          folderSize: "Folder size ",
          totalFiles: " Total Files",
          lastUpdate: "Last update",
          actions: "Actions",
          money: "$",
          yes: "Yes",
          no: "No",
          document: "CNPJ/CPF",
          recurrence: "Recurrence",
          monthly: "Monthly",
          bimonthly: "Bimonthly",
          quarterly: "Quarterly",
          semester: "Semiannual",
          yearly: "Annual",
          clear: "Clear",
          delete: "Delete",
          user: "User",
          save: "Save",
          type: "Type",
          typePlatform: "Platform",
          typeReseller: "Reseller",
          typeCompany: "Company",
          domain: "Domain",
          slug: "Subdomain",
          slugHelper: "Lowercase letters, numbers and hyphen",
          slugRequired: "A reseller needs a subdomain",
          invalidSlug: "Invalid or reserved subdomain",
          customDomain: "Custom domain",
          customDomainHelper: "E.g. panel.yourcompany.com (no http/port)",
          invalidCustomDomain: "Invalid custom domain",
          allowCustomBrand: "Own brand",
          maxCompanies: "Company limit",
          maxCompaniesHelper: "Empty = unlimited",
          invalidMaxCompanies: "Invalid company limit",
          openPanel: "Open panel",
          invoices: "Invoices",
          emptyTitle: "No companies yet",
          emptyMessage: "Companies you create will show up here.",
          dueDateHelper: "No date: 30 days from today",
          invite: "Invite",
          inviteSent: "Invite created. An e-mail was sent to the company admin.",
          inviteError: "Could not create the invite.",
          inviteDialogTitle: "Access invite",
          inviteDialogText: "Send this link to the admin of",
          inviteCopy: "Copy link",
          inviteCopied: "Link copied.",
          inviteCopyError: "Could not copy. Select the link and copy it manually.",
          inviteExpires: "Valid until",
          inviteClose: "Close",
        },
        buttons: {
          add: "Add Company",
        },
        toasts: {
          deleted: "Company deleted successfully.",
        },
        confirmationModal: {
          deleteTitle: "Delete",
          deleteMessage:
            "All company data will be lost. Open tickets for users in this company will be moved to the queue.",
        },
      },
      plans: {
        form: {
          name: "Name",
          users: "Users",
          connections: "Connections",
          campaigns: "Campaigns",
          schedules: "Schedules",
          enabled: "Enabled",
          disabled: "Disabled",
          clear: "Cancel",
          delete: "Delete",
          save: "Save",
          yes: "Yes",
          no: "No",
          money: "$",
          public: "Public",
          trial: "Trial",
          trialDays: "Trial Days",
          platformPlan: "Platform",
          readOnly: "Platform plan: read-only",
          perActiveCompanyAmount: "Amount per active company (R$)",
          perActiveCompanyAmountHelper: "Added to the fixed amount, per active company of the reseller, when the invoice is generated",
        },
      },
      helps: {
        title: "Help Center",
        settings: {
          codeVideo: "Video Code",
          description: "Description",
          clear: "Clear",
          delete: "Delete",
          save: "Save",
        },
      },
      schedules: {
        title: "Schedules",
        date: "Date",
        time: "Time",
        event: "Event",
        allDay: "All Day",
        week: "Week",
        work_week: "Work Week",
        day: "Day",
        month: "Month",
        previous: "Previous",
        next: "Next",
        yesterday: "Yesterday",
        tomorrow: "Tomorrow",
        today: "Today",
        agenda: "Agenda",
        noEventsInRange: "No events in this range.",
        confirmationModal: {
          deleteTitle: "Are you sure you want to delete this Schedule?",
          deleteMessage: "This action cannot be undone.",
        },
        table: {
          contact: "Contact",
          body: "Message",
          sendAt: "Scheduled Date",
          sentAt: "Sent Date",
          status: "Status",
          actions: "Actions",
        },
        buttons: {
          add: "New Schedule",
        },
        toasts: {
          deleted: "Schedule deleted successfully.",
        },
      },
      tags: {
        title: "Tags",
        addColumns: "+ ADD COLUMNS",
        search: "SEARCH",
        seeTicket: "SEE TICKET",
        confirmationModal: {
          deleteTitle: "Are you sure you want to delete this Tag?",
          deleteMessage: "This action cannot be undone.",
        },
        table: {
          id: "ID",
          name: "Name",
          kanban: "Kanban",
          color: "Color",
          tickets: "Tag Records",
          contacts: "Contacts",
          actions: "Actions",
        },
        buttons: {
          add: "New Tag",
        },
        toasts: {
          deleted: "Tag deleted successfully.",
        },
      },
      tagsKanban: {
        title: "Lanes",
        laneDefault: "Open",
        backToKanban: "BACK TO KANBAN",
        confirmationModal: {
          deleteTitle: "Are you sure you want to delete this Lane?",
          deleteMessage: "This action cannot be undone.",
        },
        table: {
          name: "Name",
          color: "Color",
          tickets: "Tickets",
          actions: "Actions",
        },
        buttons: {
          add: "New Lane",
        },
        toasts: {
          deleted: "Lane deleted successfully.",
        },
      },
      files: {
        title: "File Lists",
        table: {
          name: "Name",
          contacts: "Contacts",
          actions: "Action",
        },
        toasts: {
          deleted: "File list deleted successfully!",
          deletedAll: "All file lists were deleted successfully!",
        },
        buttons: {
          add: "Add",
          deleteAll: "Delete All",
        },
        confirmationModal: {
          deleteTitle: "Delete",
          deleteAllTitle: "Delete All",
          deleteMessage: "Are you sure you want to delete this list?",
          deleteAllMessage: "Are you sure you want to delete all lists?",
        },
      },
      settings: {
        success: "Settings saved successfully.",
        title: "Settings",
        tabs: {
          options: "Options",
          plans: "Plans",
          helps: "Help",
          companies: "Companies",
        },
        settings: {
          userCreation: {
            name: "User Creation",
            options: {
              enabled: "Enabled",
              disabled: "Disabled",
            },
          },
          tabs: {
            options: "Options",
            schedules: "Schedules",
            plans: "Plans",
            help: "Help",
          },
          options: {
            disabled: "Disabled",
            enabled: "Enabled",
            updating: "Updating...",
            creationCompanyUser: "Company/User Creation",
            evaluations: "Evaluations",
            ratingButtons: "Rating by buttons",
            ratingButtonsHelp: "When the ticket is closed the customer answers by tapping 👍 Great / 😐 Regular / 👎 Bad (unofficial WhatsApp). Other channels keep the text question.",
            typingIndicator: "Show \"typing…\"",
            typingIndicatorHelp: "The customer sees when the agent is typing or recording audio, and the agent sees when the customer types (non-official WhatsApp).",
            officeScheduling: "Office Scheduling",
            queueManagement: "Queue Management",
            companyManagement: "Company Management",
            connectionManagement: "Connection Management",
            sendGreetingAccepted: "Send Greeting on Accepting Ticket",
            sendMsgTransfTicket:
              "Send Transfer Message between Departments/Agents",
            checkMsgIsGroup: "Ignore Group Messages",
            chatBotType: "Bot Type",
            userRandom: "Random Agent Selection",
            buttons: "Buttons",
            acceptCallWhatsapp: "Notify that WhatsApp call is not accepted?",
            sendSignMessage: "Allow agent to choose to send Signature",
            sendGreetingMessageOneQueues:
              "Send Greeting when only one queue exists",
            sendQueuePosition: "Send Queue Position Message",
            sendFarewellWaitingTicket: "Send Farewell Message while Waiting",
            acceptAudioMessageContact:
              "Accept Audio Messages from All Contacts?",
            enableLGPD: "Enable LGPD Processing",
            requiredTag: "Required Tag to Close Ticket",
            closeTicketOnTransfer:
              "Close Ticket when Transferring to Another Queue",
            DirectTicketsToWallets: "Automatically Move Client to Wallet",
            showNotificationPending: "Show Notification for Pending Tickets",
          },
          customMessages: {
            sendQueuePositionMessage: "Queue Position Message",
            AcceptCallWhatsappMessage: "Message to Inform Call Not Accepted",
            greetingAcceptedMessage: "Greeting Message When Accepting Ticket",
            transferMessage:
              "Transfer Message - ${queue.name} = destination queue",
          },
          LGPD: {
            title: "LGPD",
            welcome: "Welcome Message (LGPD)",
            linkLGPD: "Privacy Policy Link",
            obfuscateMessageDelete: "Obfuscate Deleted Message",
            alwaysConsent: "Always Request Consent",
            obfuscatePhoneUser: "Obfuscate User Phone Number",
            enabled: "Enabled",
            disabled: "Disabled",
          },
        },
      },
      messagesList: {
        header: {
          assignedTo: "Assigned to:",
          dialogRatingTitle:
            "Would you like to leave a service rating for the client?",
          dialogClosingTitle: "Closing the service with the client!",
          dialogRatingCancel: "Resolve WITH Farewell Message",
          dialogRatingSuccess: "Resolve and Send Rating",
          dialogRatingWithoutFarewellMsg: "Resolve WITHOUT Farewell Message",
          ratingTitle: "Choose a rating menu",
          notMessage: "No message selected",
          amount: "Prospecting Value",
          buttons: {
            return: "Return",
            resolve: "Resolve",
            reopen: "Reopen",
            accept: "Accept",
            rating: "Send Rating",
            enableIntegration: "Enable Integration",
            disableIntegration: "Disable Integration",
            logTicket: "Ticket Logs",
            requiredTag: "You must assign a tag before closing the ticket.",
            greetingAcceptedMessage:
              "You must configure a greeting message when accepting the ticket.",
          },
        },
      },
      conversation: {
        unread: "{{count}} unread message",
        unread_plural: "{{count}} unread messages",
        reactions: {
          react: "React",
          more: "More emojis",
          you: "You",
          clickToRemove: "click to remove",
          unavailable: "Could not send the reaction.",
          unsupported: "This channel does not accept reactions.",
        },
        emojiPicker: {
          search: "Search emoji",
          notFound: "No emoji found",
          results: "Results",
          recent: "Recent",
          people: "Smileys & people",
          nature: "Animals & nature",
          foods: "Food & drink",
          activity: "Activities",
          places: "Travel & places",
          objects: "Objects",
          symbols: "Symbols",
          flags: "Flags",
        },
        sending: {
          sending: "Sending…",
          failed: "Not sent",
          retry: "Try again",
          discard: "Discard",
          voice: "Voice message",
        },
        jump: {
          searching: "Looking for the message…",
          loaded: "{{count}} loaded",
          loaded_plural: "{{count}} loaded",
          cancel: "Stop searching",
          notFound: "That message is not in this conversation.",
        },
        recorder: {
          label: "Audio recording",
          time: "Recording time",
          discard: "Discard recording",
          pause: "Pause recording",
          resume: "Resume recording",
          send: "Send audio",
        },
        gallery: {
          title: "Photos and videos in this conversation",
          counter: "{{current}} of {{total}}",
          previous: "Previous",
          next: "Next",
          download: "Download",
          close: "Close",
          open: "Open media {{n}}",
          imageFailed: "Could not load the image.",
          videoFailed: "This video cannot be played in the browser.",
        },
        mentions: {
          participant: "participant",
          listLabel: "Group participants",
          noNumber: "Number not available",
          admin: "Admin",
        },
      },
      messagesInput: {
        placeholderPrivateMessage:
          "Type a message or press / for quick replies",
        placeholderOpen: "Type a message or press / for quick replies",
        placeholderClosed: "Reopen or accept this ticket to send a message.",
        signMessage: "Sign",
        privateMessage: "Private Message",
      },
      contactDrawer: {
        header: "Contact Details",
        buttons: {
          edit: "Edit Contact",
          block: "Block",
          unblock: "Unblock",
        },
        extraInfo: "Additional Information",
      },
      messageVariablesPicker: {
        label: "Available Variables",
        vars: {
          contactFirstName: "First Name",
          contactName: "Name",
          user: "Agent",
          greeting: "Greeting",
          protocolNumber: "Protocol Number",
          date: "Date",
          hour: "Hour",
          ticket_id: "Ticket Number",
          queue: "Sector",
          connection: "Connection",
        },
      },
      ticketOptionsMenu: {
        schedule: "Schedule",
        delete: "Delete",
        transfer: "Transfer",
        registerAppointment: "Contact Notes",
        resolveWithNoFarewell: "Resolve without Farewell",
        acceptAudioMessage: "Accept audio messages from contact?",
        appointmentsModal: {
          title: "Ticket Notes",
          textarea: "Note",
          placeholder: "Enter the information you want to register here",
        },
        confirmationModal: {
          title: "Delete the contact's ticket",
          titleFrom: "from contact",
          message:
            "Attention! All messages related to this ticket will be lost.",
        },
        buttons: {
          delete: "Delete",
          cancel: "Cancel",
        },
      },
      messageInput: {
        tooltip: {
          signature: "Enable/Disable Signature",
          privateMessage: "Enable/Disable Private Message",
          meet: "Send video conference link",
        },
        type: {
          imageVideo: "Photos and Videos",
          cam: "Camera",
          contact: "Contact",
          meet: "Video Call",
          template: "Meta Template",
        },
      },
      confirmationModal: {
        buttons: {
          confirm: "Ok",
          cancel: "Cancel",
        },
      },
      messageOptionsMenu: {
        delete: "Delete",
        reply: "Reply",
        edit: "Edit",
        forward: "Forward",
        toForward: "Forward",
        talkTo: "Talk To",
        confirmationModal: {
          title: "Delete message?",
          message: "This action cannot be undone.",
        },
      },
      invoices: {
        table: {
          invoices: "Invoices",
          details: "Details",
          users: "Users",
          connections: "Connections",
          queue: "Queues",
          value: "Value",
          expirationDate: "Expiration Date",
          action: "Action",
          of: "Invoices of",
          back: "Back",
        },
      },
      webchatVisitor: {
        title: "Webchat customer",
        phone: "WhatsApp provided",
        unconfirmed: "unconfirmed",
        noPhone: "Not provided",
        since: "First visit",
        lastSeen: "Last seen",
        maybeSame: "May be the same customer as:",
      },
      backendErrors: {
        ERR_WEBCHAT_OUTBOUND: "Webchat only replies to people who opened the page; you cannot start a conversation through it.",
        ERR_WEBCHAT_TRANSFER: "Webchat tickets cannot be moved to a WhatsApp connection (or the other way around).",
        ERR_WEBCHAT_UNSUPPORTED: "This does not exist in webchat.",
        ERR_WEBCHAT_DISABLED: "The webchat page is switched off: the customer would not see the reply. Switch it on in Connections to reply.",
        ERR_META_COEX_ONLY: "This connection is not a coexistence connection.",
        ERR_META_COEX_SYNC_EXPIRED: "Meta only accepts the history request within 24 h of connecting.",
        ERR_REACTION_INVALID_EMOJI: "This emoji cannot be used as a reaction.",
        ERR_REACTION_INVALID_TARGET: "You cannot react to this message.",
        ERR_REACTION_TICKET_CLOSED: "This ticket is closed: reopen it to react.",
        ERR_REACTION_UNSUPPORTED_CHANNEL: "This channel does not accept reactions.",
        ERR_OFICIAL_MEDIA_TOO_LARGE: "File too large for the official API (images up to 5 MB, audio and video up to 16 MB, documents up to 100 MB).",
        ERR_OFICIAL_MEDIA_UNSUPPORTED: "The official WhatsApp API does not accept this file type.",
        ERR_INVALID_MENTIONS: "Could not mention the participants. Pick them again from the list.",
        ERR_MENTIONS_LIMIT: "Too many people mentioned: the limit is 50 per message.",
        ERR_ERP_CONTRACT_NOT_LINKED: "This contract does not belong to the customer linked to this contact.",
        ERR_NO_OTHER_WHATSAPP:
          "There must be at lest one default WhatsApp connection.",
        ERR_NO_DEF_WAPP_FOUND:
          "No default WhatsApp found. Check connections page.",
        ERR_WAPP_NOT_INITIALIZED:
          "This WhatsApp session is not initialized. Check connections page.",
        ERR_WAPP_CHECK_CONTACT:
          "Could not check WhatsApp contact. Check connections page.",
        ERR_WAPP_INVALID_CONTACT: "This is not a valid whatsapp number.",
        ERR_WAPP_DOWNLOAD_MEDIA:
          "Could not download media from WhatsApp. Check connections page.",
        ERR_TOO_MANY_LOGIN_ATTEMPTS: "Too many login attempts. Wait 15 minutes and try again.",
        ERR_INVALID_CREDENTIALS: "Authentication error. Please try again.",
        ERR_EDITING_WAPP_MSG: "Could not edit the message on WhatsApp.",
        ERR_EDIT_WINDOW_EXPIRED: "WhatsApp only allows editing up to 15 minutes after sending.",
        ERR_EDIT_NOT_SUPPORTED_CHANNEL: "This channel does not allow editing messages.",
        ERR_EDIT_NOT_OWN_MESSAGE: "You can only edit messages you sent.",
        ERR_EDIT_EMPTY: "The message cannot be empty.",
        ERR_SENDING_WAPP_MSG:
          "Error sending WhatsApp message. Check connections page.",
        ERR_DELETE_WAPP_MSG: "Couldn't delete message from WhatsApp.",
        ERR_OTHER_OPEN_TICKET:
          "There's already an open ticket for this contact.",
        ERR_SESSION_EXPIRED: "Session expired. Please login.",
        ERR_USER_CREATION_DISABLED:
          "User creation was disabled by administrator.",
        ERR_NO_PERMISSION: "You don't have permission to access this resource.",
        ERR_ALLOWED_WHATSAPPS_INVALID: "None of the selected connections exists anymore. Clear the field and pick again (or leave it empty for all).",
        ERR_DUPLICATED_CONTACT: "A contact with this number already exists.",
        ERR_NO_SETTING_FOUND: "No setting found with this ID.",
        ERR_NO_CONTACT_FOUND: "No contact found with this ID.",
        ERR_NO_TICKET_FOUND: "No ticket found with this ID.",
        ERR_NO_USER_FOUND: "No user found with this ID.",
        ERR_NO_WAPP_FOUND: "No WhatsApp found with this ID.",
        ERR_CREATING_MESSAGE: "Error while creating message on database.",
        ERR_CREATING_TICKET: "Error while creating ticket on database.",
        ERR_FETCH_WAPP_MSG:
          "Error fetching the message in WhtasApp, maybe it is too old.",
        ERR_QUEUE_COLOR_ALREADY_EXISTS:
          "This color is already in use, pick another one.",
        ERR_WAPP_GREETING_REQUIRED:
          "Greeting message is required if there is more than one queue.",
        ERR_OUT_OF_HOURS: "Outside Business Hours!",
        ERR_DOMAIN_NOT_POINTING: "The domain must point (CNAME) to app.{{baseDomain}} before it can be saved.",
        ERR_RESELLER_INACTIVE: "The reseller responsible for this account is inactive. Please contact support.",
        ERR_RESELLER_LIMIT: "The reseller's company limit has been reached.",
        ERR_PLAN_NOT_ALLOWED: "This plan is not available for this company.",
        ERR_TERMS_REQUIRED: "You must accept the terms of use to sign up.",
        ERR_TERMS_NOT_CONFIGURED: "There are no terms of use configured for this company.",
        ERR_SLUG_IN_USE: "This subdomain is already in use.",
        ERR_DOMAIN_IN_USE: "This domain is already used by another company.",
        ERR_INVALID_SLUG: "Invalid or reserved subdomain. Use lowercase letters, numbers and hyphens.",
        ERR_INVALID_DOMAIN: "Invalid domain. Enter only the host (e.g. panel.yourcompany.com), without http or port.",
      },
      messagesAPIInstructions: {
        endpoint: "Endpoint:",
        method: "Method:",
        post: "POST",
        headers: "Headers:",
        headerAuthorization:
          "Authorization Bearer (registered token) and Content-Type (application/json)",
        body: "Body:",
        fieldNumber: '"number": "558599999999"',
        fieldBody: '"body": "Message"',
        fieldUserId: '"userId": User ID or ""',
        fieldQueueId: '"queueId": Queue ID or ""',
        fieldSendSignature: '"sendSignature": Sign message - true/false',
        fieldCloseTicket: '"closeTicket": Close the ticket - true/false',
        singMessage: "Sign message - true/false",
        closeTicket: "Close the ticket - true/false",
        testSend: "The Test Send",
      },
      recurrenceSection: {
        title: "Recurrence",
        description:
          "You can choose to send the message recurrently and select the interval. If it is a one-time message, do not change anything in this section.",
        labelInterval: "Interval",
        intervalFilterValue: "Interval filter value",
        sendAsManyTimes: " Send as many times",
        shipNormallyOnNonbusinessDays: "Ship normally on non-business days",
        sendOneBusinessDayBefore: "Send one business day before",
        sendOneBusinessDayLater: "Send one business day later",
        options: {
          days: "Days",
          weeks: "Weeks",
          months: "Months",
          minutes: "Minutes",
        },
        servicePanel: {
          allowRealTime: "Service Panel",
        },
      },
      servicePanel: {
        allowRealTime: "Service Panel  ",
      },
      financial: {
        invoices: "Invoices",
        details: "Details",
        users: "Users",
        connections: "Connections",
        queues: "Queues",
        value: "Value",
        expirationDate: "Due Date",
        status: "Status",
        action: "Action",
      },
      statusFilter: {
        statusFilter: "Filter by Status",
      },
      momentsUser: {
        services: "Services:",
        pending: "Pending",
        noqueue: "NO QUEUE",
      },
      campaignsPhrase: {
        campaignsFlow: "Campaigns Flow",
        campaigns: "Campaign",
        name: "Name",
        status: "Status",
        newCampaignWithFlowByPhrase: "New campaign with flow by phrase",
        editCampaignWithFlowByPhrase: "Edit campaign with flow by phrase",
        phraseTriggerName: "Phrase trigger name",
        chooseAStream: "Choose a stream",
        whichPhraseTriggersTheFlow: " Which phrase triggers the flow?",
        selectAConnection: " Select a Connection",
        chooseAStream: "Choose a stream",
        status: " Status",
        cancel: "CANCEL",
        createCampaign: "CREATE CAMPAIGN ",
        saveCampaign: "Sale Campaign",
      },
      chatList: {
        noMessages: "No messages",
        admin: "Admin",
        member: "Member",
        searchChat: "Search chat...",
        createNewChat: "Create new chat",
        searchUser: "Search user...",
        noUserFound: "No user found",
        noUserAvailable: "No user available",
        cancel: "Cancel",
        details: "Details",
        deleteChat: "Delete Chat",
        deleteChatConfirm: "This action cannot be undone, confirm?",
        detailsTitle: "Details",
        edit: "Edit",
        delete: "Delete",
        now: "now",
        minutesAgo: "{{count}}m ago",
        hoursAgo: "{{count}}h ago",
      },
      chatMessages: {
        deleted: "This message was deleted",
        deletedAdmin: "Deleted message - visible only to administrators",
        reply: "Reply",
        edit: "Edit",
        delete: "Delete",
        forward: "Forward",
        editMessage: "Edit Message",
        save: "Save",
        cancel: "Cancel",
        deleteMessage: "Delete Message",
        deleteMessageConfirm: "Are you sure you want to delete this message?",
        forwardMessage: "Forward Message",
        selectChat: "Select chat",
        doubleClickToReply: "Double click to reply",
        edited: "(edited)",
        forwarded: "(forwarded)",
        typeMessage: "Type a message...",
        send: "Send",
        noMessages: "No messages",
        loading: "Loading...",
        replyingTo: "Replying to",
        clickToGoToOriginal: "Click to go to original message",
      },
      chatPopover: {
        reply: "Reply",
        edit: "Edit",
        delete: "Delete",
        forward: "Forward",
        cancel: "Cancel",
        confirmDelete: "Confirm Delete",
        confirm: "Confirm",
        deleteMessage: "Are you sure you want to delete this message?",
        editMessage: "Edit Message",
        save: "Save",
        forwardMessage: "Forward Message",
        selectChat: "Select chat",
        forward: "Forward",
        noChats: "No chat available",
      },
      chatIndex: {
        chats: "Chats",
        groups: "Groups",
        new: "New",
        messages: "Messages",
        search: "Search...",
        noChats: "No chat found",
        noGroups: "No group found",
        noMessages: "No messages",
        loading: "Loading...",
        error: "Error loading data",
        addGroupPhoto: "Add Group Photo",
        changeGroupPhoto: "Change Group Photo",
        groupName: "Group Name",
        groupDescription: "Group Description",
        save: "Save",
        cancel: "Cancel",
        createGroup: "Create Group",
        editGroup: "Edit Group",
        deleteGroup: "Delete Group",
        deleteGroupConfirm: "Are you sure you want to delete this group?",
        edit: "Edit",
        delete: "Delete",
        details: "Details",
        groupDetails: "Group Details",
        title: "Title",
        description: "Description",
        modal: {
          title: "Create Group",
          editTitle: "Edit Group",
          save: "Save",
          cancel: "Cancel",
          name: "Group Name",
          description: "Group Description",
          create: "Create",
          edit: "Edit",
        },
      },
      whitelabel: {
        primaryColorLight: "Primary Color (Light Theme)",
        primaryColorDark: "Primary Color (Dark Theme)",
        appName: "Application Name",
        logoLight: "Logo (Light Theme)",
        logoDark: "Logo (Dark Theme)",
        favicon: "Favicon",
        backgroundLight: "Background Image (Light Theme)",
        backgroundDark: "Background Image (Dark Theme)",
        preview: "Preview",
        delete: "Delete",
        upload: "Upload",
        availableLanguages: "Available Languages",
        atLeastOneLanguage: "At least one language must be enabled",
        inheritedHint: "Inherited from the reseller/platform until you change it",
        termsUrl: "Terms of use link",
        termsUrlHint: "Empty = acceptance not required",
        termsVersion: "Terms version",
        termsVersionHint: "Changing the version requires every company to accept again",

        sections: {
          general: "General Settings",
          generalDescription: "Configure the application name and basic information",
          colors: "Colors and Themes",
          colorsDescription: "Customize primary colors for light and dark themes",
          logos: "Logos and Images",
          logosDescription: "Upload application logos and background images",
          languages: "Available Languages",
          languagesDescription: "Select which languages will be available in the system"
        }
      }
    },
    whatsappModalRel: {
      form: {
        isOficial: "Support Report",
        ticketId: "Ticket ID",
        client: "Customer",
        number: "Number",
        agent: "Agent",
        date: "Date",
        lastMessage: "Last Message",
        fullReport: "The full report is attached above",
        resolveAndTriggerIntegration: "Resolve and Trigger Integration",
        elementNotFoundForExport: "Element not found for export.",
        reportFilename: "support_report",
      },
    },
  },
};

export { messages };
